<style>
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td{
        font-size: 0.675rem;
        height: 30px;
    }
    .tabla{
        border: 1px solid #bdbdbd;border-radius: 3px;margin-top: 3px;padding: 3px 15px;margin-left: 5px;
    }
    .secondtitle{
        color: #0663ad;
        font-weight: 600;
    }
    .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
        opacity: 0.5;
    }
    #icon .col-icon{
        color:red;
    }
    #freedays .v-input--selection-controls {
        margin-top: 0; 
        padding-top: 0;
    }
    .daydest > .v-label .theme--light{
        font-size: 14px;
    }
</style>
<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headersListar"
        :items="tarifasListar"        
        :search="search"
        class="elevation-1"
        :itemsPerPage = npagina
        :loading="loadigtable"
        loading-text="Loading... Please wait"
        :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'keyboard_arrow_left',
            nextIcon: 'keyboard_arrow_right'
        }"
        >
        <template v-slot:[`item.nfecharespuesta`]="{ item }">  
            <div v-if="item.nfecharespuesta === '01/01/1753 12:00 a. m.' ">
                <span class="red--text">----------------</span>
            </div>
            <div v-else>
                <span style="color:rgb(16 95 119);font-size: 11px;">{{item.nfecharespuesta}}</span>
            </div>               
        </template>
        <template v-slot:[`item.basis`]="{ item }">  
            <div v-if="item.basis">
                <span>{{item.basis}}</span>
            </div>             
        </template>
        <template v-slot:[`item.status`]="{ item }">
            <table style="width: 100%;min-width: 110px;">
                <tr>
                    <td style="border: 0;">
                        <v-icon v-if="item.recollecion == true" style="font-size: 20px;" :color="getColor(item.recollecionstatus)">local_shipping</v-icon>
                        <v-icon v-if="item.recollecion == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.recollecionstatus)">arrow_forward</v-icon>
                        <v-icon v-if="item.principal == true && item.basis =='AEREO'" style="font-size: 20px;" :color="getColor(item.principalstatus)">flight_takeoff</v-icon>
                        <v-icon v-if="item.principal == true && item.basis =='FCL' || item.principal == true && item.basis =='LCL'" style="font-size: 20px;" :color="getColor(item.principalstatus)">directions_boat</v-icon>
                        <v-icon v-if="item.principal == true && item.basis =='FTL' || item.principal == true && item.basis =='LTL'" style="font-size: 20px;" :color="getColor(item.principalstatus)">local_shipping</v-icon>
                        <v-icon v-if="item.entrega == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.entregastatus)">arrow_forward</v-icon>
                        <v-icon v-if="item.entrega == true" style="font-size: 20px;" :color="getColor(item.entregastatus)">local_shipping</v-icon>
                        <v-icon v-if="item.viewextra == true" style="font-size: 12px;font-weight: 600;margin-top: -15px;" :color="getColor(item.statusadicional)">add</v-icon>
                    </td>
                </tr>
            </table>
        </template>    
        <!--<template v-slot:[`item.status`]="{ item }">
            <v-chip
            dark
            style="min-width: 90px;display: table;"
            :color="getColor(item.status)"
            class="ml-0 mr-2"
            label
            small
            >
                {{ item.status}}
            </v-chip>
        </template>-->
        <!--<template v-slot:item.nfecharespuesta="{ item }">
            <template v-if="item.nfecharespuesta === '01/01/1753 12:00 a.m.'">
                <span>respuesta</span>
            </template>
            <template v-else>
                <span>-</span>
            </template>
        </template>-->
        <template v-slot:[`item.npuertoreceipt`]="{ item }">
            <template v-if="item.npuertoreceipt === 'SELECT..'">
                <span>-</span>
            </template>
            <template v-else>
                <span>{{item.npuertoreceipt}}</span>
            </template>
        </template>
        <template v-slot:[`item.npuertoloading`]="{ item }">
            <template v-if="item.npuertoloading === 'SELECT..'">
                <span>-</span>
            </template>
            <template v-else>
                <span>{{item.npuertoloading}}</span>
            </template>
        </template>
        <template v-slot:[`item.npuertodischarge`]="{ item }">
            <template v-if="item.npuertodischarge === 'SELECT..'">
                <span>-</span>
            </template>
            <template v-else>
                <span>{{item.npuertodischarge}}</span>
            </template>
        </template>
        <template v-slot:[`item.npuertodelivery`]="{ item }">
            <template v-if="item.npuertodelivery === 'SELECT..'">
                <span>-</span>
            </template>
            <template v-else>
                <span>{{item.npuertodelivery}}</span>
            </template>
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Solicitudes</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-btn icon @click="listar"><v-icon>refresh</v-icon></v-btn>
                <v-dialog
                v-model="dialog2"
                max-width="70%"
                >
                    <v-card>
                        <v-card-title
                        style="color:#043067;"
                        >
                            Enviar solicitud de cotizacíon
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <div>
                                <v-combobox
                                v-model="contactoscc"
                                hide-selected                                               
                                label="Para."
                                multiple
                                persistent-hint
                                small-chips
                                type="mail"                                            
                                >
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                presiona <kbd>enter</kbd> para crear uno nuevo
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-combobox>
                            </div>
                            <div>
                                <v-text-field v-model="cpasunto" label="asunto" single-line outlined dense></v-text-field>
                            </div>
                            <div>
                                <v-list
                                    nav
                                    dense
                                >
                                    <v-list-item-group
                                    v-model="selectedItem"
                                    color="primary"
                                    style="display: flex;"
                                    class="d-flex flex-wrap"
                                    >
                                        <v-list-item
                                            v-for="(item, i) in containerFile"
                                            :key="i"
                                            style="max-width: 25%;margin-right:20px;"
                                        >
                                            <div  v-if="item.activo==true" style="padding:0;border: 1px solid #2c5e8a;margin-right: 8px;display: flex;">
                                                <a @click="ViewFiles(item.file)"  style="width: 150px;text-decoration: none;display: flex;">
                                                    <v-list-item-icon style="margin-right:0;">
                                                        <v-icon color="#2c5e8a">text_snippet</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title style="color: black;" v-text="item.file"></v-list-item-title>
                                                    </v-list-item-content>
                                                </a>
                                                <a style="display: flex;" @click="deleteItemFile(item)"><v-icon style="color:#2c5e8a;">close</v-icon></a>
                                            </div>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </div>
                            <div >
                                <ckeditor :editor="editor" @ready="onReady" v-model="editorcp"></ckeditor>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#1583da"
                                text
                                @click="EnviraMail()"
                            >
                                Enviar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog
                        v-model="dialog3"
                        max-width="700px"
                    >
                        <v-card>
                        <v-card-title style="flex-direction: column;">
                            <v-row style="width: 100%;">
                                <v-col md="8">
                                    <v-label style="width: 100%;text-align: center;">Numero de Solicitud: <span>{{' ' + edittarifa.ncotizacion}}</span></v-label>
                                </v-col>
                                <v-col style="text-align: end;">
                                    <v-label>Ejecutivo:{{' ' + edittarifa.nusuario}}</v-label>
                                </v-col>
                            </v-row>
                            <v-row style="width: 100%;">
                                <v-col>
                                    <v-label>Customer: <span class="secondtitle">{{ ' ' + edittarifa.ncustumer}}</span></v-label>
                                </v-col>
                            </v-row>
                        <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text >
                        <v-list-item-group v-model="model" multiple color="#0069bd">
                        </v-list-item-group>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                            color="primary"
                            text
                            @click="dialog3 = false"
                            >
                            Close
                            </v-btn>
                        </v-card-actions>
                        </v-card>
                </v-dialog>
                <v-dialog  v-model="adModal4" 
                persistent
                transition="dialog-bottom-transition"
                max-width="95%" scrollable>
                    <v-card>
                        <v-toolbar style="color: rgb(17, 91, 183);
                                font-weight: 600;">
                                <v-toolbar-title>Registrar Tarifa para la Solicitud {{' #' + edittarifa.ncotizacion}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon  @click="adModal4=false"><v-icon>clear</v-icon></v-btn>
                                <v-progress-linear
                                    :active="loadingsave"
                                    indeterminate = 3000
                                    absolute
                                    bottom
                                    color="primary accent-6"
                                ></v-progress-linear>
                            </v-toolbar>
                        <v-card-text><br>
                            <v-row style="display: flex;flex-direction: column;">
                                <!--<v-col v-if="edittarifa.basis =='LCL' || edittarifa.basis =='LTL'">
                                    <v-simple-table max-width="90%" class="elevation-3">
                                        <thead>
                                            <tr style="text-align: center;">
                                                <th>Quantity</th>
                                                <th>Package</th>
                                                <th>Large</th>
                                                <th>Width</th>
                                                <th>Hight</th>
                                                <th>Weight</th>
                                                <th>Volumetric Weight</th>
                                                <th>Actual Weight</th>
                                                <th>Stackable</th>
                                                <th>Rate</th>
                                                <th v-if="this.$store.state.usuario.rol !=='PricingAgente'">provider</th>
                                                <th v-if="this.$store.state.usuario.rol === 'PricingAgente'">Agent</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="det in addpackages" :key="det.num" style="text-align: center;">
                                                <td>
                                                    {{det.quantity}}
                                                </td>
                                                <td>{{det.tnpackage}}</td>
                                                <td>{{det.large}}</td>
                                                <td>{{det.width}}</td>
                                                <td>{{det.high}}</td>
                                                <td>{{det.weight}}</td>
                                                <td>{{(det.large * det.width) * det.high}}</td>
                                                <td>{{det.weight * det.quantity}}</td>
                                                <td>
                                                   <span v-if="det.stackable == true">Yes</span>
                                                   <span v-else>Not</span> 
                                                </td>
                                                <td><v-text-field v-model="ratepackage"></v-text-field></td>
                                                <td v-if="this.$store.state.usuario.rol !=='PricingAgente'"><v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dentse v-model="idproviderr" placeholder="Provider" :items="provider"></v-select></td>
                                                <td v-if="this.$store.state.usuario.rol ==='PricingAgente'"><v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dentse v-model="idagent" placeholder="Agent" :items="agents"></v-select></td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-col>-->
                                <div v-if="viewtarifaprincipal == false && viewpickup == false && viewdelivery == false ">
                                    <v-col v-if="edittarifa.basis =='LCL' || edittarifa.basis =='LTL' || edittarifa.basis =='AEREO'" style="margin-bottom: 12px;">
                                        <v-simple-table max-width="90%" class="elevation-3">
                                            <thead>
                                                <tr style="text-align: center;">
                                                    <th>Quantity</th>
                                                    <th>Package</th>
                                                    <th>Large</th>
                                                    <th>Width</th>
                                                    <th>Hight</th>
                                                    <th>Weight</th>
                                                    <th>Volumetric Weight</th>
                                                    <th>Actual Weight</th>
                                                    <th>Stackable</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in addpackages" :key="det.num" style="text-align: center;">
                                                    <td>
                                                        {{det.quantity}}
                                                    </td>
                                                    <td>{{det.tnpackage}}</td>
                                                    <td>{{det.large}}</td>
                                                    <td>{{det.width}}</td>
                                                    <td>{{det.high}}</td>
                                                    <td>{{addCommas(parseFloat(det.weight).toFixed(2))}}</td>
                                                    <td>{{addCommas(parseFloat((det.large * det.width) * det.high).toFixed(2))}}</td>
                                                    <td>{{addCommas(parseFloat(det.weight * det.quantity).toFixed(2))}}</td>
                                                    <td>
                                                    <span v-if="det.stackable == true"><span style="font-size: 18px;color: #009688;font-weight: 700;" class="material-icons">done</span></span>
                                                    <span v-else><span style="font-size: 18px;color: red;font-weight: 700;"  class="material-icons">clear</span></span> 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-col>
                                    <v-col v-else>
                                        <v-simple-table width="90%" class="elevation-3">
                                            <thead>
                                                <tr>
                                                    <th style="text-align:center;font-size: 10px;">QUANTITY</th>
                                                    <th style="text-align:center;font-size: 10px;">SIZE</th>
                                                    <th style="text-align:center;font-size: 10px;">TYPE</th>
                                                    <th style="text-align:center;font-size: 10px;">BASIS</th>
                                                    <th style="text-align:center;font-size: 10px;">OPERATION TYPE</th>
                                                    <th style="text-align:center;font-size: 10px;">TOTAL WEIGHT</th>
                                                </tr>
                                            </thead>
                                        <tbody v-for="det in containers" :key="det.num">
                                                    <tr style="margin-bottom: 8px;border-bottom: 1px solid red;">
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.quantity}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.size}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.type}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{edittarifa.basis}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{edittarifa.tipoOp}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{addCommas(det.nweight)}}</td>
                                                    </tr><br>
                                                </tbody>
                                        </v-simple-table>
                                    </v-col>
                                </div>
                                <div v-if="viewtarifaprincipal == true || viewpickup == true || viewdelivery == true" style="margin-bottom: 12px;">
                                    <v-col  >
                                        <table style="width: 100%;" v-if="edittarifa.basis =='FCL' || edittarifa.basis =='FTL'">
                                            <thead>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">SELECT</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">QUANTITY</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">SIZE</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">TYPE</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">BASIS</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">OPERATION TYPE</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">TOTAL WEIGHT</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in containers" :key="det.num">
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">
                                                        <v-checkbox
                                                        style="width: 20px;"
                                                            v-model="det.containerseleccionado"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.quantity}}</td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.size}}</td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.type}}</td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{edittarifa.basis}}</td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{edittarifa.tipoOp}}</td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{addCommas(det.nweight)}}</td>
                                                </tr>
                                            </tbody>
                                        </table><br>
                                        <table style="width: 100%;" v-if="edittarifa.basis =='LTL' || edittarifa.basis =='LCL' || edittarifa.basis =='AEREO'">
                                            <thead>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Quantity</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Package</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Large</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Width</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Hight</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Weight</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Volumetric Weight</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Actual Weight</th>
                                                <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">Stackable</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in addpackages" :key="det.num" style="margin-bottom: 8px;border-bottom: 1px solid red;">
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">
                                                        {{det.quantity}}
                                                    </td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.tnpackage}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.large}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.width}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.high}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.weight}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{ parseFloat((det.large * det.width) * det.high).toFixed(2)}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">{{det.weight * det.quantity}}</td>
                                                    <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;">
                                                        <span v-if="det.stackable == true">Yes</span>
                                                        <span v-else>Not</span> 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table ><br>
                                        <v-simple-table class="elevation-3">
                                            <thead>
                                                <tr>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">TARIFF</th>
                                                    <!--<th style="text-align:center;font-size: 10px;padding: 0;">TYPE</th>
                                                    <th style="text-align:center;font-size: 10px;border-bottom: 1px solid #d9d8d8;color:#02597b;">TOTAL WEIGHT</th>-->
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">CURRENCY</th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;" v-if="edittarifa.basis =='FCL'">FREE DAYS
                                                        <table style="width: 100%;">
                                                            <thead>
                                                                <tr>
                                                                    <th style="text-align: center;color: black;font-weight: 500;">
                                                                        <div><span style="color: #053f8c;font-weight: 600;">ORIGIN</span></div>
                                                                        <div>
                                                                            <v-checkbox style="margin-top:0!important;padding-top:0;font-size: 10px;"
                                                                            v-model="chekfreedaysorigin"
                                                                            :label="edittarifa.freedaysorigin"
                                                                            color="info"
                                                                            value="infoorigin"
                                                                            hide-details
                                                                            dense
                                                                            ></v-checkbox>
                                                                        </div>
                                                                    </th>
                                                                    <th style="text-align: center;color: black;font-weight: 500;">
                                                                        <div>
                                                                            <span style="color: #053f8c;font-weight: 600;">DESTINATION</span>
                                                                        </div>
                                                                        <div>
                                                                            <v-checkbox
                                                                            class="daydest"
                                                                            v-model="checkfreedaysdest"
                                                                            :label="edittarifa.freedaysdest"
                                                                            color="info"
                                                                            value="infodest"
                                                                            hide-details
                                                                            dense
                                                                            style="margin-top:0!important;padding-top:0;font-size: 10px;"
                                                                            ></v-checkbox>
                                                                        </div>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            
                                                        </table>
                                                    </th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">RATE</th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">PROVIDER</th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">VALIDITY</th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">Additional Fees</th>
                                                    <th style="text-align:center;font-size: 10px;padding: 0;">Observations</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                <tr v-for="list in tarifasprincipales" :key="list.num" style="margin-bottom: 8px;border-bottom: 1px solid red;">
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 60px;"><span>{{list.descripcion}}</span></td>
                                                    <!--<td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 60px;"><span>{{det.size + " " + det.type}}</span></td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 60px;"><span>{{addCommas(parseFloat(det.nweight).toFixed(2)) + " Kg."}}</span></td>-->
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 80px;"><v-select style="width:100%;font-size: 12px;" dense return-object item-text="text" item-value="value" placeholder="* Currency"  v-model="list.idmoneda" :items="monedas"></v-select></td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 180px;" v-if="edittarifa.basis =='FCL'">
                                                        <table style="width: 100%;">
                                                            <tr>
                                                                <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;"><v-text-field type="number" style="width: 80px;font-size: 12px;" :disabled="chekfreedaysorigin" dense v-model="list.freedaysorigin"></v-text-field></td>
                                                                <td style="text-align: center;color: black;font-weight: 500;font-size: 10px;"><v-text-field type="number" style="width: 80px;font-size: 12px;" :disabled="checkfreedaysdest" dense v-model="list.freedaysdest"></v-text-field></td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width:80px;"><v-text-field style="font-size: 12px;" type="number" v-model="list.rate" placeholder="Rate" dense></v-text-field></td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width:140px;"><v-select item-text="text" return-object item-value="value" style="font-size: 12px;width: 140px;" dense v-model="list.idprovider" placeholder="Provider" :items="provider"></v-select></td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;" v-if="agent==true"><v-select item-text="text" return-object item-value="value" style="font-size: 12px;margin: 0 8px;width: 130px;" dense v-model="list.idagent" placeholder="Agent" :items="agents"></v-select></td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;width: 130px;" >
                                                        <v-menu
                                                            style="display: flex;flex-direction: column;width: 130px;"
                                                            v-model="list.fecha"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="290px"
                                                            dense
                                                        >
                                                            <template v-slot:activator="{ on, attrs }" >
                                                                <v-text-field
                                                                    style="padding: 0;font-size: 12px;"
                                                                    v-model="list.date"
                                                                    placeholder="Date"
                                                                    readonly
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                            v-model="list.date"
                                                            @input="list.fecha = false"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;" >
                                                        <v-textarea
                                                            outlined
                                                            name="input-7-4"
                                                            placeholder="Additional Fees"
                                                            v-model="list.tarifaAd"
                                                            dense
                                                        ></v-textarea>
                                                    </td>
                                                    <td  style="text-align: center;color: black;font-weight: 500;font-size: 10px;border-bottom: 1px solid #d9d8d8;" >
                                                        <v-textarea
                                                            outlined
                                                            name="input-7-4"
                                                            placeholder="Observations"
                                                            v-model="list.observaciones"
                                                            dense
                                                        ></v-textarea>
                                                    </td>
                                                </tr><br>
                                            </tbody>
                                        </v-simple-table><br>
                                    </v-col>
                                    <v-row>
                                        <v-col style="display: flex;justify-content: end;">
                                            <v-radio-group v-model="radios" row :mandatory="false">
                                                <v-radio label="Exclusive rate" value="1"></v-radio>
                                                <v-radio label="General rate" value="2"></v-radio>
                                            </v-radio-group>
                                            <v-btn style="margin-left:8px;" color="primary" @click="agregartarifas()">ADD</v-btn>
                                        </v-col>
                                    </v-row>   
                                    <v-row><!--Table Tarifas-->
                                        <v-col>
                                            <v-data-table
                                                :headers="headerst"
                                                :items="tarifas"
                                                sort-by="calories"
                                                class="elevation-1"
                                                style="width:100%"
                                            >
                                                <template slot="item" slot-scope="tarifas">
                                                    <tr v-if="tarifas.item.activo == true">
                                                        <td style="text-align: center">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        @click="editItemc(tarifas.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        edit
                                                                    </v-icon>
                                                                </template>
                                                                <span>Edit</span>
                                                            </v-tooltip>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        @click="deleteItemc(tarifas.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                    </v-icon>
                                                                </template>
                                                                <span>Delete</span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td style="text-align: center">{{tarifas.item.ntype}}</td>
                                                        <td style="text-align: center">{{tarifas.item.descripcion}}</td>
                                                        <td style="text-align: center">{{addCommas(tarifas.item.nrate)}}</td>
                                                        <td style="text-align: center">{{tarifas.item.nidprovider}}</td>
                                                        <td style="text-align: center">{{tarifas.item.freedaysorigin}}</td>
                                                        <td style="text-align: center">{{tarifas.item.freedasydestination}}</td>
                                                        <td style="text-align: center">{{tarifas.item.tarifaAd}}</td>
                                                        <td style="text-align: center">{{tarifas.item.observaciones}}</td>
                                                        <td style="text-align: center">{{tarifas.item.ex}}</td>
                                                        <td style="text-align: center">{{tarifas.item.fechavigencia}}</td>
                                                    </tr>
                                                </template>  
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row style="width: auto;" v-if="rolejecutivo == 'Operaciones' && adicionalespricing === true || rolejecutivo == 'Pricing' && adicionalespricing === true || rolejecutivo == 'PricingAgente' && adicionalesagentes === true">
                                    <v-col md="12" sm="11" style="margin-top: 12px;border: 1px solid #9e9e9e;border-radius: 3px;padding: px; display: flex;">
                                        <br>
                                        <table style="width: 100%;margin:0 auto;display: block;">
                                            <tr v-if="edittarifa.vgm == true" style="display: flex;align-items: baseline;border-bottom: 1px solid #9e9e9e;">
                                                <td style="text-align: center;width: 80px;">
                                                    <span style="color: black;font-weight: 500;">VGM</span>  
                                                </td>    
                                                <td style="text-align: center;color: black;font-weight: 500;width: 200px;">
                                                    <v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dense  outlined v-model="chargeidprovidervgm" placeholder="Provider" :items="provider"></v-select>
                                                </td>
                                                <td>
                                                    <v-select item-text="text" return-object item-value="value" style="width: 90px;font-size: 14px;margin: 0 8px;" dense  outlined v-model="currencyvgm" placeholder="Currency" :items="monedas"></v-select>
                                                </td>
                                                <td style="width: 200px;">
                                                    <v-text-field dense outlined v-model="chargeRatevgm" type="number" label="Rate"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRemarksvgm" label="Remarks"></v-text-field>
                                                </td>
                                                <td style="margin-left:3px;">
                                                    <v-checkbox style="margin-top: 0px;"
                                                    v-model="chargeivavgm"
                                                    label="Iva"
                                                    color="info"
                                                    value="iva"
                                                    hide-details
                                                    dense
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                            <tr v-if="edittarifa.insurance == true" style="display: flex;align-items: baseline;border-bottom: 1px solid #9e9e9e;margin-top: 10px;">
                                                <td style="text-align: center;width: 80px;">
                                                    <span style="color: black;font-weight: 500;">Insurance</span>  
                                                </td>    
                                                <td style="text-align: center;color: black;font-weight: 500;width: 200px;">
                                                    <v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dense  outlined v-model="chargeidproviderins" placeholder="Provider" :items="provider"></v-select>
                                                </td>
                                                <td>
                                                    <v-select item-text="text" return-object item-value="value" style="width: 90px;font-size: 14px;margin: 0 8px;" dense  outlined v-model="currencyinsurance" placeholder="Currency" :items="monedas"></v-select>
                                                </td>
                                                <td style="width: 200px;">
                                                    <v-text-field dense outlined v-model="chargeRateins" type="number" label="Rate"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRemarksins" label="Remarks"></v-text-field>
                                                </td>
                                                <td style="margin-left:3px;">
                                                    <v-checkbox style="margin-top: 0px;"
                                                    v-model="chargeivains"
                                                    label="Iva"
                                                    color="info"
                                                    value="iva"
                                                    hide-details
                                                    dense
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                            <tr v-if="edittarifa.custom == true" style="display: flex;align-items: baseline;border-bottom: 1px solid #9e9e9e;margin-top: 10px;">
                                                <td style="text-align: center;width: 80px;">
                                                    <span style="color: black;font-weight: 500;">Customs</span>  
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field v-model="conceptoocustom" dense outlined label="*Concept" style="font-size: 14px;width: 200px;"></v-text-field>
                                                </td> 
                                                <td style="text-align: center;color: black;font-weight: 500;width: 200px;margin-left:8px;">
                                                    <v-select item-text="text" return-object item-value="value" style="font-size: 14px" dense  outlined v-model="chargeidprovidercus" placeholder="Provider" :items="provider"></v-select>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-select item-text="text" return-object item-value="value" style="width: 90px;font-size: 14px;" dense  outlined v-model="currencycustoms" placeholder="Currency" :items="monedas"></v-select>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRatecus" style="width: 95px;" type="number" label="Rate"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="percustom" label="Per"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRemarkscus" label="Remarks"></v-text-field>
                                                </td>
                                                <td style="margin-left:3px;">
                                                    <v-checkbox style="margin-top: 0px;"
                                                    v-model="chargeivacus"
                                                    label="Iva"
                                                    color="info"
                                                    value="iva"
                                                    hide-details
                                                    dense
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                            <tr v-if="edittarifa.maneuvers == true" style="display: flex;align-items: baseline;border-bottom: 1px solid #9e9e9e;margin-top: 10px;">
                                                <td style="text-align: center;width: 80px;">
                                                    <span style="color: black;font-weight: 500;">Maneuvers</span>  
                                                </td>    
                                                <td style="text-align: center;color: black;font-weight: 500;width: 200px;">
                                                    <v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dense  outlined v-model="chargeidproviderma" placeholder="Provider" :items="provider"></v-select>
                                                </td>
                                                <td>
                                                    <v-select item-text="text" return-object item-value="value" style="width: 90px;font-size: 14px;margin: 0 8px;" dense  outlined v-model="currencymaneuvers" placeholder="Currency" :items="monedas"></v-select>
                                                </td>
                                                <td style="width: 200px;">
                                                    <v-text-field dense outlined v-model="chargeRatema" type="number" label="Rate"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRemarksma" label="Remarks"></v-text-field>
                                                </td>
                                                <td style="margin-left:3px;">
                                                    <v-checkbox style="margin-top: 0px;"
                                                    v-model="chargeivama"
                                                    label="Iva"
                                                    color="info"
                                                    value="iva"
                                                    hide-details
                                                    dense
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                            <tr v-if="edittarifa.custody == true" style="display: flex;align-items: baseline;border-bottom: 1px solid #9e9e9e;margin-top: 10px;">
                                                <td style="text-align: center;width: 80px;">
                                                    <span style="color: black;font-weight: 500;">Custody</span>  
                                                </td>    
                                                <td style="text-align: center;color: black;font-weight: 500;width: 200px;">
                                                    <v-select item-text="text" return-object item-value="value" style="font-size: 14px;margin: 0 8px;" dense  outlined v-model="chargeidprovidercustody" placeholder="Provider" :items="provider"></v-select>
                                                </td>
                                                <td>
                                                    <v-select item-text="text" return-object item-value="value" style="width: 90px;font-size: 14px;margin: 0 8px;" dense  outlined v-model="currencycustody" placeholder="Currency" :items="monedas"></v-select>
                                                </td>
                                                <td style="width: 200px;">
                                                    <v-text-field dense outlined v-model="chargeRatecustody" type="number" label="Rate"></v-text-field>
                                                </td>
                                                <td style="margin-left:8px;">
                                                    <v-text-field dense outlined v-model="chargeRemarkscustody" label="Remarks"></v-text-field>
                                                </td>
                                                <td style="margin-left:3px;">
                                                    <v-checkbox style="margin-top: 0px;"
                                                    v-model="chargeivacustody"
                                                    label="Iva"
                                                    color="info"
                                                    value="iva"
                                                    hide-details
                                                    dense
                                                    ></v-checkbox>
                                                </td>
                                            </tr>
                                            <tr style="display: flex;">
                                                <td colspan="8" style="text-align: end;width: 100%;"><br>
                                                    <v-btn color="primary" @click="agregarchargeaditional">ADD</v-btn>
                                                </td>
                                            </tr>
                                            <tr style="display: flex;">
                                                <td colspan="8">
                                                    <v-simple-table>
                                                        <thead>
                                                            <tr >
                                                                <th style="text-align: center;font-size:">OPTIONS</th>
                                                                <th style="text-align: center;">CHARGES</th>
                                                                <th style="text-align: center;">CONCEPT</th>
                                                                <th style="text-align: center;">PROVIDER</th>
                                                                <th style="text-align: center;">CURRENCY</th>
                                                                <th style="text-align: center;">RATE</th>
                                                                <th style="text-align: center;">PER</th>
                                                                <th style="text-align: center;">REMARKS</th>
                                                                <th style="text-align: center;">IVA</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-for="det in chargeaditional" :key="det.num">
                                                            <tr  v-if="det.activo == true" style="text-align: center;">
                                                                <td>
                                                                    <v-col style="min-width: 90px;padding: 0;" class="col-icon">
                                                                        <v-tooltip top>
                                                                            <template v-slot:activator="{ on, attrs }">  
                                                                                <v-icon
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    small
                                                                                    @click="edittadicional(det)"
                                                                                    style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                                                                    color="rgb(51 106 144)"
                                                                                >
                                                                                    edit
                                                                                </v-icon>
                                                                            </template>
                                                                            <span>Edit</span>
                                                                        </v-tooltip>
                                                                        <v-tooltip top>
                                                                            <template v-slot:activator="{ on, attrs }">  
                                                                                <v-icon
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    small
                                                                                    @click="deletltarifa(det)"
                                                                                    style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                                                                    color="rgb(51 106 144)"
                                                                                >
                                                                                delete
                                                                                </v-icon>
                                                                            </template>
                                                                            <span>Delete</span>
                                                                        </v-tooltip>
                                                                    </v-col>      
                                                                </td>
                                                                <td>{{det.charge}}</td>
                                                                <td>{{det.concept}}</td>
                                                                <td>{{det.provider}}</td>
                                                                <td>{{det.moneda}}</td>
                                                                <td>{{det.rate}}</td>
                                                                <td>{{det.per}}</td>
                                                                <td>{{det.remarks}}</td>
                                                                <td>
                                                                    <span v-if="det.iva == true"> YES</span>
                                                                    <span v-else>NOT</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-col>
                                </v-row>    
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn color="green darken-1" text="text" @click="adModal4=false">
                                 Cancelar
                             </v-btn>
                             <v-btn color="orange darken1" text="text" @click="actualizarTarifa()" :disabled="ejecutando">
                                 Aceptar
                             </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }"  id="icon">
            <v-col style="min-width: 90px;padding: 0;" class="col-icon">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">  
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="enviarTarifaMil(item)"
                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                            color="rgb(51 106 144)"
                        >
                            email
                        </v-icon>
                    </template>
                    <span>apply for</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">  
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="agregarTarifa(item)"
                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                            color="rgb(51 106 144)"
                        >
                         reply
                         </v-icon>
                    </template>
                    <span>reply</span>
                </v-tooltip>
            </v-col>      
        </template>
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        color="cyan darken-2" 
        top
        timeout="6000"
        >
            {{ mensaje }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>            
        </v-snackbar>
      <template>
        <div class="vld-parent">
          <loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage" 
          ></loading>
        </div>
      </template>
      <template>
        <!--<loader object="#33b1ff" color1="#96d5fd" color2="#0178df" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>-->
      </template>
      <template>
        <v-dialog
            v-model="dialoview"
            width="800px"
            style="z-index:100;"
            >
            <v-card>
                <div id="viewer">
                    <PDFJSViewer style="width: 100%;" :path="`${path}`" :fileName="`${name}`"/>
                </div>
            </v-card>
        </v-dialog>
      </template>
  </v-layout>
</template>
<script>
import axios from 'axios'
import Vue from 'vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import Loading from 'vue-loading-overlay';
import PDFJSViewer from './PDFJSViewer'
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

export default {
    name: 'app',
    data(){
        return{
            npagina:15,
            ejecutando:true,
            loadingsave:false,
            loadigtable:false,
            chargeRemarksvgm:'',
            chargeRemarksins:'',
            chargeRemarksma:'',
            chargeRemarkscus:'',
            date: '',
            menu2:false,
            dialoview:false,
            name: '', //change which pdf file loads
            path: 'SISTEMAOPTIMAGL/lib/pdfjs-2.5.207-dist/web/viewer.html',
            selectedItem:'',
            agent:false,
            chekfreedaysorigin:false,
            checkfreedaysdest:false,
            isLoading: false,
            fullPage: true,
            cpasunto:'',
            contactoscc:'',
            freedaysorigin:'',
            freedaysdest:'',
            model:'',
            codigo:'',
            search:'',
            editor: DecoupledEditor,
            editorcp:'', 
            snackbar:false,
            mensaje:'',
            radios:'1',
            tarifaAd:'',
            observaciones:'',
            dialogEnviarMail:false,
            dialog:false,
            dialog2:false,
            dialog3:false,
            adModal4:false,
            tarifasListar:[],
            headersListar:[
                {text:'OPTIONS',value:'opciones',align:'center', sortable: false},
                {text:'TARIFF N°',value:'ncotizacion',align:'center', sortable: false},
                {text:'USER',value:'nusuario',align:'center', sortable: false},
                {text:'CUSTOMER NAME',value:'ncustumer',align:'center', sortable: false},
                {text:'OPERATION TYPE',value:'tipoOp',align:'center', sortable: false},
                {text:'BASIS',value:'basis',align:'center', sortable: false},
                {text:'RECEIPT',value:'npuertoreceipt',align:'center', sortable: false},
                {text:'POL',value:'npuertoloading',align:'center', sortable: false},
                {text:'POD',value:'npuertodischarge',align:'center', sortable: false},
                {text:'DESTINATION',value:'npuertodelivery',align:'center', sortable: false},
                {text:'ORDER DATE',value:'nfechacreate',align:'center', sortable: false},
                {text:'REPLY DATE',value:'nfecharespuesta',align:'center', sortable: false},
                {text:'REMARKS',value:'remarks',align:'center', sortable: false},
                {text:'STATUS',value:'status',align:'center', sortable: false},
            ],
            editedIndex:-1,
            edittarifa:[],
            headers: [       
                { text: 'Quantity', value: 'quantity' , sortable: false,align:'center'},
                { text: 'Size', value: 'size', sortable: false ,align:'center'},
                { text: 'Type', value: 'type' , sortable: false,align:'center'},
                { text: 'Basis', value: 'basis' , sortable: false,align:'center'},
                { text: 'Operation Tipe', value: 'tipoOp' , sortable: false,align:'center'},
                { text: 'Total Weight', value: 'nweight' , sortable: false,align:'center'},
                { text: 'Currency', value: 'currency' , sortable: false,align:'center'},
                { text: 'Free days', value: 'freedays' , sortable: false,align:'center'},
                { text: 'Rate', value: 'rate' , sortable: false,align:'center'},
                { text: 'Provider', value: 'idprovider', sortable: false ,align:'center'},
                { text: 'Validity', value: 'vigencia', sortable: false ,align:'center'},
                /*{ text: 'Agent', value: 'idagent' , sortable: false,align:'center'},*/
            ],
            headerst: [       
                /*{ text: 'Quantity', value: 'quantity' , sortable: false,align:'center'},
                { text: 'Size', value: 'size', sortable: false ,align:'center'},
                { text: 'Type', value: 'type' , sortable: false,align:'center'},
                { text: 'Total Weight', value: 'nweight' , sortable: false,align:'center'},*/
                { text: 'Options', value: 'options' , sortable: false,align:'center'},
                { text: 'Type', value: 'ntype' , sortable: false,align:'center'},
                { text: 'Tariff', value: 'descripcion' , sortable: false,align:'center'},
                { text: 'Rate', value: 'nrate' , sortable: false,align:'center'},
                { text: 'Provider', value: 'nidprovider', sortable: false ,align:'center'},
                { text: 'Free days origin', value: 'freedaysorigin', sortable: false ,align:'center'},
                { text: 'Free days destination', value: 'freedasydestination', sortable: false ,align:'center'},
                { text: 'Additional Fees', value: 'tarifaAd' , sortable: false,align:'center'},
                { text: 'Observaciones', value: 'observaciones' , sortable: false,align:'center'},
                { text: '-', value: 'ex' , sortable: false,align:'center'},
                { text: 'Validity', value: 'vigencia', sortable: false ,align:'center'},
            ],
            containers:[],
            editcontainer:{
                quantity:'',                
                size:'',
                idsize:0,
                type:'',
                idtype:0,
                weight:'',
                rate:''
            },
            provider:[],
            agents:[],
            tarifas:[],
            editedIndextaf:-1,
            idscotizacion:0,
            numcontainers:[],
            text:'',
            containerFile:[],
            ncotizacion:'',
            nusuario:'',
            editedIndextarif:-1,
            addpackages:[],
            /**************Aditional Charges*************/
            chargeaditional:[],
            chargeidprovidervgm:'',
            chargeRatevgm:'',
            chargeivavgm:'',
            chargeidproviderins:'',
            chargeRateins:'',
            chargeivains:'',
            chargeidprovidercus:'',
            chargeRatecus:'',
            chargeivacus:'',
            chargeidproviderma:'',
            chargeRatema:'',
            chargeivama:'',
            chargeidprovidercustody:'',
            chargeRatecustody:'',
            chargeivacustody:'',
            chargeRemarkscustody:'',
            /***************************************************/
            fechapickup:null,
            menupickup:null,
            menuprinmcipal:null,
            fechaprincipal:null,
            menudelivery:null,
            fechadelivery:null,
            /***************************************************/
            listart:[],
            rolejecutivo:'',
            editindestl:-1,
            viewtarifaprincipal:false,
            viewpickup:false,
            viewdelivery:false,
            /***********************************/
            tarifasprincipales:[],
            adicionalespricing:false,
            adicionalesagentes:false,
            edittarifa:[],
            basis:'',
            monedas:[],
            idmoneda:0,
            moneda:'',
            nprovider:'',
            idprovider:0,
            idlistartarifarate:0,
            currencycustody:1,
            currencymaneuvers:1,
            currencycustoms:1,
            currencyinsurance:1,
            currencyvgm:1,
            /**********custom******/
            conceptoocustom:'',
            percustom:'',
            idrol:0,
        }
    },
    created(){
        this.listar();
        this.select();
    },
    computed: {
      computedDateFormatpickup () {
        return this.formatDate(this.fechapickup)
      },
      computedDateFormatprincipal(){
        return this.formatDate(this.fechaprincipal)
      },
      computedDateFormatdelivery(){
        return this.formatDate(this.fechadelivery)
      }
    },
    components: {
      Loading,
      PDFJSViewer
    },
    methods:{
        /*******************************************************/
        edittadicional(item){
            this.editindestl = this.chargeaditional.indexOf(item)
            var iva;
            if(item.charge == 'VGM'){
                this.chargeidprovidervgm = item.idprovider;
                this.chargeRatevgm = item.rate;
                this.chargeRemarksvgm = item.remarks;
                this.currencyvgm = item.idmoneda;
                if(item.iva == true){
                    iva = 'iva'
                }
                this.chargeivavgm = iva;
            }
            if(item.charge == 'Insurance'){
                this.chargeidproviderins = item.idprovider;
                this.chargeRateins = item.rate;
                this.chargeRemarksins = item.remarks;
                this.currencyinsurance = item.idmoneda;
                if(item.iva == true){
                    iva = 'iva'
                }
                this.chargeivains = iva;
            }
            if(item.charge == 'Customs'){
                this.chargeidprovidercus = item.idprovider;
                this.chargeRatecus = item.rate;
                this.chargeRemarkscus = item.remarks;
                this.percustom = item.per;
                this.conceptoocustom = item.concept;
                this.currencycustoms = item.idmoneda;
                if(item.iva == true){
                    iva = 'iva'
                }
                this.chargeivacus = iva;
            }
            if(item.charge == 'Maneuvers'){
                this.chargeidproviderma = item.idprovider;
                this.chargeRatema = item.rate;
                this.currencymaneuvers = item.idmoneda;
                this.chargeRemarksma = item.remarks;
                if(item.iva == true){
                    iva = 'iva'
                }
                this.chargeivama = iva;
            }
        },
        agregarchargeaditional(){
            this.ejecutando = false;
            var iva;
            var niva;
            var idmonedacustom;
            var idmonedacurrency;
            var idmonedavgm;
            var idmonedacurrency;
            var idmonedacharge;
            var idmonedacustomtext;
            var idmonedacurrencytext;
            var idmonedavgmtext;
            var idmonedacurrencytext;
            var idmonedachargetext;
            if(this.editindestl > -1){
                var charge;
                var provider;
                var idprovider;
                var rate;
                var remarks;
                var iva;
                var iva2;   
                var moneda;
                var idmoneda;
                var concept;
                var per;
                if(this.chargeaditional[this.editindestl].charge == 'Customs'){
                    if(this.chargeidprovidercus.text == undefined){
                        provider = this.chargeaditional[this.editindestl].provider;
                    }else{
                        provider = this.chargeidprovidercus.text;
                    }
                    if(this.chargeidprovidercus.value == undefined){
                        idprovider = this.chargeaditional[this.editindestl].idprovider;
                    }else{
                        idprovider = this.chargeidprovidercus.value;
                    }
                    rate = this.chargeRatecus;
                    remarks = this.chargeRemarkscus;
                    concept = this.conceptoocustom;
                    per = this.percustom;

                    if(this.currencycustoms.text == undefined){
                        moneda = this.chargeaditional[this.editindestl].moneda;
                    }else{
                        moneda = this.currencycustoms.text;
                    }
                    if(this.currencycustoms.value == undefined){
                        idmoneda = this.chargeaditional[this.editindestl].idmoneda;
                    }else{
                        idmoneda = this.currencycustoms.value;
                    }

                    if(this.chargeivacus == 'iva'){
                        iva = true;
                       // iva = true
                    }else{
                        iva = false;
                        ///iva = 'Not'
                    } 
                }
                if(this.chargeaditional[this.editindestl].charge == 'VGM'){
                    if(this.chargeidprovidervgm.text == undefined){
                        provider = this.chargeaditional[this.editindestl].provider;
                    }else{
                        provider = this.chargeidprovidervgm.text;
                    }
                    if(this.chargeidprovidervgm.value == undefined){
                        idprovider = this.chargeaditional[this.editindestl].idprovider;
                    }else{
                        idprovider = this.chargeidprovidervgm.value;
                    }
                    rate = this.chargeRatevgm;
                    remarks = this.chargeRemarksvgm;

                    if(this.currencyvgm.text == undefined){
                        moneda = this.chargeaditional[this.editindestl].moneda;
                    }else{
                        moneda = this.currencyvgm.text;
                    }
                    if(this.currencyvgm.value == undefined){
                        idmoneda = this.chargeaditional[this.editindestl].idmoneda;
                    }else{
                        idmoneda = this.currencyvgm.value;
                    }

                    if(this.chargeivavgm == 'iva'){
                        iva = true;
                       // iva = 'Yes'
                    }else{
                        iva = false;
                       // iva = 'Not'
                    } 
                }
                if(this.chargeaditional[this.editindestl].charge == 'Insurance'){
                    if(this.chargeidproviderins.text == undefined){
                        provider = this.chargeaditional[this.editindestl].provider;
                    }else{
                        provider = this.chargeidproviderins.text;
                    }
                    if(this.chargeidproviderins.value == undefined){
                        idprovider = this.chargeaditional[this.editindestl].idprovider;
                    }else{
                        idprovider = this.chargeidproviderins.value;
                    }
                    rate = this.chargeRateins;
                    remarks = this.chargeRemarksins;

                    if(this.currencyinsurance.text == undefined){
                        moneda = this.chargeaditional[this.editindestl].moneda;
                    }else{
                        moneda = this.currencyinsurance.text;
                    }
                    if(this.currencyinsurance.value == undefined){
                        idmoneda = this.chargeaditional[this.editindestl].idmoneda;
                    }else{
                        idmoneda = this.currencyinsurance.value;
                    }
                    if(this.chargeivains == 'iva'){
                        iva = true;
                    }else{
                        iva = false;
                    } 
                }
                if(this.chargeaditional[this.editindestl].charge == 'Maneuvers'){
                    if(this.chargeidproviderma.text == undefined){
                        provider = this.chargeaditional[this.editindestl].provider;
                    }else{
                        provider = this.chargeidproviderma.text;
                    }
                    if(this.chargeidproviderma.value == undefined){
                        idprovider = this.chargeaditional[this.editindestl].idprovider;
                    }else{
                        idprovider = this.chargeidproviderma.value;
                    }
                    rate = this.chargeRatema;
                    remarks = this.chargeRemarksma;

                    if(this.currencymaneuvers.text == undefined){
                        moneda = this.chargeaditional[this.editindestl].moneda;
                    }else{
                        moneda = this.currencymaneuvers.text;
                    }
                    if(this.currencymaneuvers.value == undefined){
                        idmoneda = this.chargeaditional[this.editindestl].idmoneda;
                    }else{
                        idmoneda = this.currencymaneuvers.value;
                    }
                    if(this.chargeivama == 'iva'){
                        iva = true;
                    }else{
                        iva = false;
                    } 
                }
                if(this.chargeaditional[this.editindestl].charge == 'custody'){
                    if(this.chargeidprovidercustody.text == undefined){
                        provider = this.chargeaditional[this.editindestl].provider;
                    }else{
                        provider = this.chargeidprovidercustody.text;
                    }
                    if(this.chargeidprovidercustody.value == undefined){
                        idprovider = this.chargeaditional[this.editindestl].idprovider;
                    }else{
                        idprovider = this.chargeidprovidercustody.value;
                    }
                    rate = this.chargeRatecustody;
                    remarks = this.chargeRemarkscustody;

                    if(this.currencycustody.text == undefined){
                        moneda = this.chargeaditional[this.editindestl].moneda;
                    }else{
                        moneda = this.currencycustody.text;
                    }
                    if(this.currencycustody.value == undefined){
                        idmoneda = this.chargeaditional[this.editindestl].idmoneda;
                    }else{
                        idmoneda = this.currencycustody.value;
                    }
                    if(this.chargeivama == 'iva'){
                        iva = true;
                    }else{
                        iva = false;
                    } 
                }
                Object.assign(this.chargeaditional[this.editindestl],{
                        idlistarifarate:this.chargeaditional[this.editindestl].idlistarifarate,
                        charge:this.chargeaditional[this.editindestl].charge,
                        provider:provider,
                        idprovider:idprovider,
                        rate:Number(rate),
                        remarks:remarks,
                        idmoneda:idmoneda,
                        moneda:moneda,
                        concept:concept,
                        per:per,
                        iva:iva,
                        niva:niva,
                        activo:true
                });
                this.limpiarcargosadicionales();

            }else{
                if(this.chargeidprovidervgm.value != undefined && this.chargeRatevgm !=''){
                    if(this.chargeivavgm == 'iva'){
                        iva = true;
                        //iva = 'Yes';
                    }else{
                        iva = false;
                        //iva = 'Not'
                    }
                    if(this.currencyvgm.value == undefined){
                        idmonedavgm = 1;
                        idmonedavgmtext = 'USD';
                    }else{
                        idmonedavgm = this.currencyvgm.value;   
                        idmonedavgmtext = `${this.currencyvgm.text}`;
                    }
                    this.chargeaditional.push({
                        idlistarifarate:0,
                        charge:'VGM',
                        provider:this.chargeidprovidervgm.text,
                        idprovider:this.chargeidprovidervgm.value,
                        rate:Number(this.chargeRatevgm),
                        remarks:this.chargeRemarksvgm,
                        iva:iva,
                        idmoneda:idmonedavgm,
                        moneda:idmonedavgmtext,
                        niva:niva,
                        activo:true
                    });
                    this.limpiarcargosadicionales();
                }
                if(this.chargeidproviderins.value != undefined && this.chargeRateins !=''){
                    if(this.chargeivains == 'iva'){
                        iva = true;
                        //iva = 'Yes'
                    }else{
                        iva = false;
                        //iva = 'Not'
                    }
                    if(this.currencyinsurance.value == undefined){
                        idmonedacurrency = 1;
                        idmonedacurrencytext = 'USD';
                    }else{
                        idmonedacurrency = this.currencyinsurance.value;
                        idmonedacurrencytext = `${this.currencyinsurance.text}`;
                    }
                    this.chargeaditional.push({
                        idlistarifarate:0,
                        charge:'Insurance',
                        provider:this.chargeidproviderins.text,
                        idprovider:this.chargeidproviderins.value,
                        rate:Number(this.chargeRateins),
                        remarks:this.chargeRemarksins,
                        iva:iva,
                        idmoneda:idmonedacurrency,
                        moneda:idmonedacurrencytext,
                        niva:niva,
                        activo:true
                    });
                    this.limpiarcargosadicionales();
                }
                if(this.chargeidprovidercus.value != undefined && this.chargeRatecus !='' && this.chargeRemarkscus !=''){
                    if(this.chargeivacus == 'iva'){
                        iva = true;
                        //iva = 'Yes'
                    }else{
                        iva = false;
                        //iva = 'Not'
                    }
                    if(this.currencycustoms.value == undefined){
                        idmonedacustom = 1;
                        idmonedacustomtext = 'USD';
                    }else{
                        idmonedacustom = this.currencycustoms.value;
                        idmonedacustomtext = `${this.currencycustoms.text}`;
                    }
                    this.chargeaditional.push({
                        idlistarifarate:0,
                        charge:'Customs',
                        provider:this.chargeidprovidercus.text,
                        idprovider:this.chargeidprovidercus.value,
                        rate:Number(this.chargeRatecus),
                        remarks:this.chargeRemarkscus,
                        idmoneda:idmonedacustom,
                        moneda:idmonedacustomtext,
                        concept:this.conceptoocustom,
                        per:this.percustom,
                        iva:iva,
                        niva:niva,
                        activo:true
                    });
                    this.limpiarcargosadicionales();
                }else{
                    if(this.edittarifa.custom == true){
                        window.alert('Add Customs Remarks')
                    }
                }
                if(this.chargeidproviderma.value != undefined && this.chargeRatema !=''){
                    if(this.chargeivama == 'iva'){
                        iva = true;
                        //iva = 'Yes'
                    }else{
                        iva = false;
                        //iva = 'Not'
                    }
                    if(this.currencymaneuvers.value == undefined ){
                        idmonedacurrency = 1;
                        idmonedacurrencytext = 'USD';
                    }else{
                        idmonedacurrency = this.currencymaneuvers.value;
                        idmonedacurrencytext = `${this.currencymaneuvers.text}`;
                    }
                    this.chargeaditional.push({
                        idlistarifarate:0,
                        charge:'Maneuvers',
                        provider:this.chargeidproviderma.text,
                        idprovider:this.chargeidproviderma.value,
                        rate:Number(this.chargeRatema),
                        remarks:this.chargeRemarksma,
                        idmoneda:idmonedacurrency,
                        moneda:idmonedacurrencytext,
                        iva:iva,
                        niva:niva,
                        activo:true
                    });
                    this.limpiarcargosadicionales();
                }
                if(this.chargeidprovidercustody.value != undefined && this.chargeRatecustody !=''){
                    if(this.chargeivacustody == 'iva'){
                        iva = true;
                        //iva = 'Yes'
                    }else{
                        iva = false;
                       // iva = 'Not'
                    }
                    if(this.currencycustody.value == undefined){
                        idmonedacharge = 1;
                        idmonedachargetext = 'USD';
                    }else{
                        idmonedacharge = this.currencycustody.value;
                        idmonedachargetext = `${this.currencycustody.text}`;
                    }
                    this.chargeaditional.push({
                        idlistarifarate:0,
                        charge:'custody',
                        provider:this.chargeidprovidercustody.text,
                        idprovider:this.chargeidprovidercustody.value,
                        rate:Number(this.chargeRatecustody),
                        remarks:this.chargeRemarkscustody,
                        idmoneda:idmonedacharge,
                        moneda:idmonedachargetext,
                        iva:iva,
                        niva:niva,
                        activo:true
                    });
                    this.limpiarcargosadicionales();
                }
            }
        },
        limpiarcargosadicionales(){
            this.chargeRatema = '';
            this.chargeRatecus = '';
            this.chargeRateins = '';
            this.chargeRatevgm = '';
            this.chargeidproviderma = '';
            this.chargeidprovidercus = '';
            this.chargeidproviderins = '';
            this.chargeidprovidervgm = '';
            this.chargeivama = '';
            this.chargeivacus = '';
            this.chargeivains  = '';
            this.chargeivavgm = '';
            this.chargeRemarksma = '';
            this.chargeRemarkscus = '';
            this.chargeRemarksins = '';
            this.chargeRemarksvgm = '';
            this.conceptoocustom = '';
            this.percustom = '';
            this.editindestl = -1;
        },
        deletltarifa(item){
           const index = this.chargeaditional.indexOf(item)
           var resp = confirm('Are you sure you want to delete this ' + this.chargeaditional[index].charge + '?');
           if(resp == true){
                this.chargeaditional[index].activo = false;
                this.ejecutando = false;
           }
        },
        /*******************************************************/
        formatDate(date){
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        deleteItemFile (item) {
           const index = this.containerFile.indexOf(item)
           var resp = confirm('Are you sure you want to delete this file?');
           if(resp == true){
                this.containerFile[index].activo = false;
           }
        },
        ViewFiles(name){
            //this.name = this.nusuario + "/" + this.ncotizacion + "/" + name;
            this.name = this.edittarifa.idcustumer + "/" + this.ncotizacion + "/" + name;
            this.dialoview = true;
        },
        onReady( editor )  {
          // Insert the toolbar before the editable area.
          editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
        },
        onCancel() {
            console.log('User cancelled the loader.')
        },
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            this.rolejecutivo = this.$store.state.usuario.rol;
            this.idrol = this.$store.state.usuario.iddecrol;
            var consulta;
            this.loadigtable = true;
            if(this.rolejecutivo  == 'Administrador'){
                consulta ='ListarScotizacionadmin';
            }else{
                consulta ='ListarScotizacion/' + this.rolejecutivo +'/' + this.idrol;
            }
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            var buy = [];
            me.tarifasListar = [];
            var tarifasListar = [];
            axios.get('api/ListaTarifasPricings/'+ consulta ,configuracion).then(function(response){
                buy=response.data;
                for(var i = 0; i < buy.length; i++){
                    var principal = false;
                    var principalstatus = false;
                    var recollecion = false;
                    var recollecionstatus = false;
                    var entrega = false;
                    var entregastatus = false;
                    var viewextra = false;
                    var statusadicional = false;
                    
                    if(me.rolejecutivo == 'Pricing' ||  me.rolejecutivo == 'PricingAgente' || me.rolejecutivo == 'Operaciones'){
                        if(me.rolejecutivo != 'Operaciones'){
                            if(buy[i].principalratePricing == true){
                                principal = true;
                            }
                            if(buy[i].statusPrincipalRatePricing == true){
                                principalstatus = true;
                            }
                            if(buy[i].pickupPricing == true){
                                recollecion = true;
                            }
                            if(buy[i].statusPickupPricing == true){
                                recollecionstatus = true;
                            }
                            if(buy[i].deliveryPricing == true){
                                entrega = true; 
                            }
                            if(buy[i].statusDeliveriPricing == true){
                                entregastatus = true;
                            }  
                        }
                        if(buy[i].maneuvers == true || buy[i].vgm == true || buy[i].insurance == true || buy[i].custody == true || buy[i].custom == true){
                            viewextra = true;
                            statusadicional = buy[i].statusAdicional;
                        }
                    }
                    if(me.rolejecutivo == 'PricingTerrestre'){
                        if(buy[i].principalrateLocal == true){
                            principal = true;
                        }
                        if(buy[i].statusPrincipalRateLocal == true ){
                            principalstatus = true;
                        }
                        if(buy[i].pickupLocal == true){
                            recollecion = true;
                        }
                        if(buy[i].statusPickupLocal == true ){
                            recollecionstatus = true;
                        }
                        if(buy[i].deliveryLocal == true){
                            entrega = true;
                        }
                        if(buy[i].statusDeliveryLocal == true ){
                            entregastatus = true;
                        }
                    }
                    if(me.rolejecutivo == 'PricingAgente'){
                        if(buy[i].principalrateAgents == true){
                            principal = true;
                        }
                        if(buy[i].statusPrincipalRateAgents == true){
                            principalstatus = true;
                        }
                        if(buy[i].pickupAgents == true){
                            recollecion = true;
                        }
                        if(buy[i].statusPickupAgents == true){
                            recollecionstatus = true;
                        }
                        if(buy[i].deliveryAgents == true){
                            entrega = true;
                        }
                        if(buy[i].statusDeliveryAgents == true){
                            entregastatus = true;
                        }
                    }
                    if(me.idrol == 1){
                        if(recollecion == true || entrega == true || principal == true){
                            tarifasListar.push({
                                agente:buy[i].agente,
                                basis:buy[i].basis,
                                clas:buy[i].clas,
                                comodity:buy[i].comodity,
                                custody:buy[i].custody,
                                custom:buy[i].custom,
                                delivery:buy[i].delivery,
                                dentrofbl:buy[i].dentrofbl,
                                direcciondeliverypcompleta:buy[i].direcciondeliverypcompleta,
                                direccionreceipcompleta:buy[i].direccionreceipcompleta,
                                fechacreate:buy[i].fechacreate,
                                fechaedit:buy[i].fechaedit,
                                fecharespuesta:buy[i].fecharespuesta,
                                filehazardous:buy[i].filehazardous,
                                foodgrade:buy[i].foodgrade,
                                freedaysdest:buy[i].freedaysdest,
                                freedaysorigin:buy[i].freedaysorigin,
                                hazardous:buy[i].hazardous,
                                idbasis:buy[i].idbasis,
                                idcustumer:buy[i].idcustumer,
                                idinland:buy[i].idinland,
                                idlistatarifa:buy[i].idlistatarifa,
                                idportdelivery:buy[i].idportdelivery,
                                idportdischarge:buy[i].idportdischarge,
                                idportloading:buy[i].idportloading,
                                idportreceipt:buy[i].idportreceipt,
                                idscotizacion:buy[i].idscotizacion,
                                idtipoOp:buy[i].idtipoOp,
                                idusuario:buy[i].idusuario,
                                insurance:buy[i].insurance,
                                local:buy[i].local,
                                maneuvers:buy[i].maneuvers,
                                ncotizacion:buy[i].ncotizacion,
                                ncustumer:buy[i].ncustumer,
                                nfechacreate:buy[i].nfechacreate,
                                nfechaedit:buy[i].nfechaedit,
                                nfecharespuesta:buy[i].nfecharespuesta,
                                npuertodelivery:buy[i].npuertodelivery,
                                npuertodischarge:buy[i].npuertodischarge,
                                npuertoloading:buy[i].npuertoloading,
                                npuertoreceipt:buy[i].npuertoreceipt,
                                nusuario:buy[i].nusuario,
                                pickup:buy[i].pickup,
                                pricing:buy[i].pricing,
                                remarks:buy[i].remarks,
                                status:buy[i].status,
                                tarifaadicional:buy[i].tarifaadicional,
                                tarifaprincipal:buy[i].tarifaprincipal,
                                tipoOp:buy[i].tipoOp,
                                un:buy[i].un,
                                vgm:buy[i].vgm,
                                entrega:entrega,
                                recollecion:recollecion,
                                principal:principal,
                                recollecionstatus:recollecionstatus,
                                entregastatus:entregastatus,
                                principalstatus:principalstatus,
                                statusadicional:statusadicional,
                                viewextra:viewextra,
                                activo:buy[i].activo
                            });
                        }
                    }
                    if(me.idrol == 0){
                        tarifasListar.push({
                            agente:buy[i].agente,
                            basis:buy[i].basis,
                            clas:buy[i].clas,
                            comodity:buy[i].comodity,
                            custody:buy[i].custody,
                            custom:buy[i].custom,
                            delivery:buy[i].delivery,
                            dentrofbl:buy[i].dentrofbl,
                            direcciondeliverypcompleta:buy[i].direcciondeliverypcompleta,
                            direccionreceipcompleta:buy[i].direccionreceipcompleta,
                            fechacreate:buy[i].fechacreate,
                            fechaedit:buy[i].fechaedit,
                            fecharespuesta:buy[i].fecharespuesta,
                            filehazardous:buy[i].filehazardous,
                            foodgrade:buy[i].foodgrade,
                            freedaysdest:buy[i].freedaysdest,
                            freedaysorigin:buy[i].freedaysorigin,
                            hazardous:buy[i].hazardous,
                            idbasis:buy[i].idbasis,
                            idcustumer:buy[i].idcustumer,
                            idinland:buy[i].idinland,
                            idlistatarifa:buy[i].idlistatarifa,
                            idportdelivery:buy[i].idportdelivery,
                            idportdischarge:buy[i].idportdischarge,
                            idportloading:buy[i].idportloading,
                            idportreceipt:buy[i].idportreceipt,
                            idscotizacion:buy[i].idscotizacion,
                            idtipoOp:buy[i].idtipoOp,
                            idusuario:buy[i].idusuario,
                            insurance:buy[i].insurance,
                            local:buy[i].local,
                            maneuvers:buy[i].maneuvers,
                            ncotizacion:buy[i].ncotizacion,
                            ncustumer:buy[i].ncustumer,
                            nfechacreate:buy[i].nfechacreate,
                            nfechaedit:buy[i].nfechaedit,
                            nfecharespuesta:buy[i].nfecharespuesta,
                            npuertodelivery:buy[i].npuertodelivery,
                            npuertodischarge:buy[i].npuertodischarge,
                            npuertoloading:buy[i].npuertoloading,
                            npuertoreceipt:buy[i].npuertoreceipt,
                            nusuario:buy[i].nusuario,
                            pickup:buy[i].pickup,
                            pricing:buy[i].pricing,
                            remarks:buy[i].remarks,
                            status:buy[i].status,
                            tarifaadicional:buy[i].tarifaadicional,
                            tarifaprincipal:buy[i].tarifaprincipal,
                            tipoOp:buy[i].tipoOp,
                            un:buy[i].un,
                            vgm:buy[i].vgm,
                            entrega:entrega,
                            recollecion:recollecion,
                            principal:principal,
                            recollecionstatus:recollecionstatus,
                            entregastatus:entregastatus,
                            principalstatus:principalstatus,
                            statusadicional:statusadicional,
                            viewextra:viewextra,
                            activo:buy[i].activo
                        });
                    }
                    if(me.idrol == 2 && viewextra == true){
                        tarifasListar.push({
                            agente:buy[i].agente,
                            basis:buy[i].basis,
                            clas:buy[i].clas,
                            comodity:buy[i].comodity,
                            custody:buy[i].custody,
                            custom:buy[i].custom,
                            delivery:buy[i].delivery,
                            dentrofbl:buy[i].dentrofbl,
                            direcciondeliverypcompleta:buy[i].direcciondeliverypcompleta,
                            direccionreceipcompleta:buy[i].direccionreceipcompleta,
                            fechacreate:buy[i].fechacreate,
                            fechaedit:buy[i].fechaedit,
                            fecharespuesta:buy[i].fecharespuesta,
                            filehazardous:buy[i].filehazardous,
                            foodgrade:buy[i].foodgrade,
                            freedaysdest:buy[i].freedaysdest,
                            freedaysorigin:buy[i].freedaysorigin,
                            hazardous:buy[i].hazardous,
                            idbasis:buy[i].idbasis,
                            idcustumer:buy[i].idcustumer,
                            idinland:buy[i].idinland,
                            idlistatarifa:buy[i].idlistatarifa,
                            idportdelivery:buy[i].idportdelivery,
                            idportdischarge:buy[i].idportdischarge,
                            idportloading:buy[i].idportloading,
                            idportreceipt:buy[i].idportreceipt,
                            idscotizacion:buy[i].idscotizacion,
                            idtipoOp:buy[i].idtipoOp,
                            idusuario:buy[i].idusuario,
                            insurance:buy[i].insurance,
                            local:buy[i].local,
                            maneuvers:buy[i].maneuvers,
                            ncotizacion:buy[i].ncotizacion,
                            ncustumer:buy[i].ncustumer,
                            nfechacreate:buy[i].nfechacreate,
                            nfechaedit:buy[i].nfechaedit,
                            nfecharespuesta:buy[i].nfecharespuesta,
                            npuertodelivery:buy[i].npuertodelivery,
                            npuertodischarge:buy[i].npuertodischarge,
                            npuertoloading:buy[i].npuertoloading,
                            npuertoreceipt:buy[i].npuertoreceipt,
                            nusuario:buy[i].nusuario,
                            pickup:buy[i].pickup,
                            pricing:buy[i].pricing,
                            remarks:buy[i].remarks,
                            status:buy[i].status,
                            tarifaadicional:buy[i].tarifaadicional,
                            tarifaprincipal:buy[i].tarifaprincipal,
                            tipoOp:buy[i].tipoOp,
                            un:buy[i].un,
                            vgm:buy[i].vgm,
                            entrega:entrega,
                            recollecion:recollecion,
                            principal:principal,
                            recollecionstatus:recollecionstatus,
                            entregastatus:entregastatus,
                            principalstatus:principalstatus,
                            statusadicional:statusadicional,
                            viewextra:viewextra,
                            activo:buy[i].activo
                        });
                    }
                }
                me.tarifasListar = tarifasListar;
                me.loadigtable = false;
            }).catch(function(error){
                console.log(error);
            });
        },
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var providerArray = [];
            var agentArray = [];
            var monedasArray = [];

            axios.get('api/Monedas/SelectMonedaTarifa',configuracion).then(function(response){            
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            });  
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){            
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectAgente',configuracion).then(function(response){            
                agentArray=response.data;
                agentArray.map(function(x){
                    me.agents.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        ListarFile(ids){
            
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            var listarfile = [];
            me.containerFile = [];
            axios.get('api/HazardousFiles/ListarHazardous/' + ids,configuracion).then(function(response){                
                listarfile = response.data;
                listarfile.map(function(x){
                    me.containerFile.push({
                        file:x.file,
                        activo:true,
                    })
                })
            }).catch(function(error){
                console.log(error);
            });
        },
        enviarTarifaMil(item){
            this.dialog2 = true;
            this.editedIndex = this.tarifasListar.indexOf(item)               
            this.edittarifa = Object.assign({}, item)
            this.ncotizacion = this.edittarifa.ncotizacion;
            this.nusuario = this.edittarifa.nusuario;
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            me.addpackages = [];
            me.containers  = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
                var basis = '';
                var tipoO = '';
                var vgm = '';
                var custom = '';
                var insurance = '';
                var maneuvers = '';
                var comodity = '';
                var foodgrade = '';
                var npuertoreceipt = '';
                var npuertoloading = '';
                var npuertodischarge = '';
                var npuertodelivery = '';
                var freedaysorigin = '';
                var freedaysdest = '';
                var remarks = '';
                var direccionreceipcompleta = '';
                var direcciondeliverypcompleta = '';
                var freedaysorigin = '';
                var freedaysdest = '';
                var containers = '';
                var inland='';
                var i;
                var basis2='';
                basis='';

                if(me.edittarifa.basis != ''){
                    //basis = basis + '<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" style='+"'"+'border-collapse:collapse'+"'"+'><td width=170 valign=top style='+"'"+'width:127.2pt;border:solid windowtext 1.0pt;background:#2E74B5;padding:0cm 5.4pt 0cm 5.4pt'+"'"+'><p class=MsoNormal><b><span style='+"'"+'font-size:12.0pt;font-family:"Calibri Light",sans-serif;color:white'+"'"+'>Basis:<o:p></o:p></span></b></p></td><td width=419 valign=top style='+"'"+'width:314.2pt;border:solid windowtext 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt'+"'"+'><p class=MsoNormal><b><span style='+"'"+'font-size:12.0pt;color:black'+"'"+'>FCL<o:p></o:p></span></b></p></td></tr></table>'
                    //basis = "<table><tr><td class='clasbasis' style='width: 250px !important;'>Prueba de Sistemas</td></tr></table>";
                   //  basis = basis + '<span style="color:#232121"><strong>Basis: </span><span style="color:#023f8c">' + me.edittarifa.basis + '</strong></span>';
                     basis = basis + '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Basis: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.basis + '</td></tr>';
                }
                me.editorcp= basis;
                console.log(me.edittarifa.basis)
                
                if(me.edittarifa.tipoOp != ''){
                    tipoO = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;"></td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.tipoOp + '</td></tr>';
                }
                if(me.edittarifa.vgm == true){
                    vgm = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">VGM: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> Yes </td></tr>';
                }
                if(me.edittarifa.custom == true){
                    custom = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Custom: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> Yes</td></tr>';
                }
                if(me.edittarifa.insurance == true){
                    insurance = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Insurance: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> Yes </td></tr>';
                }
                if(me.edittarifa.maneuvers == true){
                    maneuvers = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Maneuvers: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> Yes </td></tr>';
                }
                if(me.edittarifa.comodity != ''){
                    comodity = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Comodity: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.comodity + '</td></tr>';
                }
                if(me.edittarifa.foodgrade != ''){
                    foodgrade = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Foodgrade: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.foodgrade + '</td></tr>';
                }
                if(me.edittarifa.npuertoreceipt != '' & me.edittarifa.npuertoreceipt != 'SELECT..'){
                    npuertoreceipt = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Pick Up </td></tr>';
                }
                if(me.edittarifa.npuertoloading != '' & me.edittarifa.npuertoloading != 'SELECT..'){
                    npuertoloading = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POL: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.npuertoloading + '</td></tr>';
                }
                if(me.edittarifa.npuertodischarge != '' & me.edittarifa.npuertodischarge != 'SELECT..'){
                    npuertodischarge = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POD: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.npuertodischarge + '</td></tr>';
                }
                if(me.edittarifa.npuertodelivery != '' & me.edittarifa.npuertodelivery != 'SELECT..'){
                    npuertodelivery = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Delivery: </td></tr>';
                }
                if(me.edittarifa.freedaysorigin != ''){
                    freedaysorigin = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Days off at origin: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.freedaysorigin + '</td></tr>';
                }
                if(me.edittarifa.freedaysdest != ''){
                    freedaysdest = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Days off at destination: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.freedaysdest + '</td></tr>';
                }
                if(me.edittarifa.remarks != ''){
                    remarks = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Remarks: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.remarks + '</td></tr>';
                }
                if(me.edittarifa.idinland != ''){
                    if(me.edittarifa.idinland == 1){
                        inland = '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Inland: </td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">Rail</td></tr>';
                    }
                }
                if(me.edittarifa.direccionreceipcompleta != ''){
                    npuertoreceipt = npuertoreceipt + '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;"></td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.direccionreceipcompleta + '</td></tr>';
                }
                if(me.edittarifa.direcciondeliverypcompleta != ''){
                    npuertodelivery = npuertodelivery + '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">' + me.edittarifa.direcciondeliverypcompleta + '</td></tr>';
                }
                
            axios.get('api/DatosContainerUnits/ListarContainers/'+ me.edittarifa.idscotizacion,configuracion).then(function(response){                
                me.containers = response.data;
                if(me.containers.length >= 1){
                    containers = '<br><br><span style="color: #191919;"><strong>Containers:</strong></span><table style="border: 1px solid #000000;"><tr></tr><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Quantity</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Size</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Type</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Weight</span></td><td><span style="text-align: center;color: black;">Total Weight</span></td>';
                    for(i=0;  i < me.containers.length; i++){
                        var quantity = me.containers[i].quantity;
                        var nweight = me.addCommas(me.containers[i].nweight); 
                        var Total1; 
                        var Total; 
                        
                        Total1 =parseFloat(me.containers[i].quantity * me.containers[i].weight).toFixed(2);
                        Total = me.addCommas(Total1);
                        containers = containers + '<tr><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + me.containers[i].quantity +'</span></td><td style="border: 1px solid #000000;"><span style="color: black;">'+ me.containers[i].size +'</span></td><td><span style="color: black;">' + me.containers[i].type + '</span></td><td style="text-align: center;"><span style="color: black;">' + nweight + ' Kg.</span></td><td style="text-align: center;"><span style="color: black;">' + Total + ' Kg.</span></td></tr>'
                    }
                    containers = containers + '</table>'; 
                    var equipo= '';              
                    equipo = equipo + '<tr><td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">EQUIPO SOLICITADO:</td><td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;"><table><tr><td>uno</td><td>dos</td></tr></table> </td></tr>'; 
                    me.editorcp='<table style="width: 90%;  border-collapse: collapse;">'+tipoO+basis+equipo+vgm+custom+insurance+maneuvers+comodity+foodgrade+npuertoreceipt+npuertoloading+npuertodischarge+npuertodelivery+freedaysorigin+freedaysdest+remarks+inland+direccionreceipcompleta+direcciondeliverypcompleta+'</table>';                    
                    me.cpasunto = 'Solicitud de Cotización '+ me.edittarifa.ncotizacion;
                    me.ListarFile(me.edittarifa.idscotizacion);
                }
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Packages/ListarPackage/'+ me.edittarifa.idscotizacion,configuracion).then(function(response){                
                me.addpackages=response.data;
                if(me.addpackages.length >= 1){
                    containers='<br><br><span style="color: #191919;"><strong>Packages:</strong></span><table><tr><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Quantity</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Package</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Lenth</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Width</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Height</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Volumetric weight</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Actual weight</span></td><td style="border: 1px solid #000000;"><span style="text-align: center;color: black;">Stackable</span></td></tr>'
                    for(i=0;  i < me.addpackages.length; i++){
                        var volumen1;
                        var volumen;
                        var gross;
                        var stackable;
                        if(me.addpackages[i].stackable == true){
                            stackable = 'yes';
                        }else{
                            stackable = 'not';
                        }

                        var pwidth = 0;
                        var plarge = 0;
                        var phigh = 0;
                        var weight = 0;
                        var pesovolumetrico = 0;
                        var pesovolcompleto = 0;
                        if(me.addpackages[i].idlongitud== 4 ){ //Centimetros a Metros
                            plarge = parseFloat(me.addpackages[i].large / 100).toFixed(2);
                            pwidth = parseFloat(me.addpackages[i].width/ 100).toFixed(2);
                            phigh = parseFloat(me.addpackages[i].high / 100).toFixed(2);
                        }
                        if(me.addpackages[i].idlongitud == 2){ //Pies a Metros
                            plarge = parseFloat(me.addpackages[i].large / 3.28084).toFixed(2);
                            pwidth = parseFloat(me.addpackages[i].width / 3.28084).toFixed(2);
                            phigh = parseFloat(me.addpackages[i].high / 3.28084).toFixed(2);
                        }
                        if(me.addpackages[i].idlongitud == 3){ //Pies a Metros
                            plarge = parseFloat(me.addpackages[i].large / 39.3701).toFixed(2);
                            pwidth = parseFloat(me.addpackages[i].width / 39.3701).toFixed(2);
                            phigh = parseFloat(me.addpackages[i].high / 39.3701).toFixed(2);
                        }
                        if(me.addpackages[i].idlongitud == 1){
                            plarge = me.addpackages[i].large;
                            pwidth = me.addpackages[i].width;
                            phigh = me.addpackages[i].high;
                        }
                        if(me.addpackages[i].idpeso  == 1){
                            weight = me.addpackages[i].weight
                        }
                        if(me.addpackages[i].idpeso == 2){//Toneladas a Kilogramos
                            weight = parseFloat(me.addpackages[i].weight * 1000).toFixed(2); 
                        }
                        if(me.addpackages[i].idpeso == 4){//Libras a Kilogramos
                            weight = parseFloat(me.addpackages[i].weight * 0.453592).toFixed(2); 
                        }
                        if(me.addpackages[i].idpeso == 5){//Libras a Kilogramos
                            weight = parseFloat(me.addpackages[i].weight / 1000).toFixed(2); 
                        }
                        if(me.edittarifa.idbasis == 5){
                            pwidth = pwidth * 100;
                            plarge = plarge* 100;
                            phigh = phigh * 100;
                            pesovolumetrico = parseFloat(((pwidth * plarge) * phigh) / 6000).toFixed(2);
                            pesovolumetrico =parseFloat(pesovolumetrico * me.addpackages[i].quantity).toFixed(2);
                            me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                            pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';
                        }else{
                            pesovolumetrico = parseFloat(((pwidth * plarge) * phigh)).toFixed(2);
                            pesovolumetrico = pesovolumetrico * me.addpackages[i].quantity;
                            me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                            pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                        }
                        var actualweight = me.addpackages[i].quantity * weight;
                        containers = containers + '<tr><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + me.addpackages[i].quantity +'</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;"border: 1px solid #000000;">' + me.addpackages[i].tnpackage +'</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + plarge + '  Mts.</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + pwidth +'  Mts.</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + phigh +'  Mts.</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + pesovolcompleto +' </span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + actualweight +' Kg.</span></td><td style="text-align: center;border: 1px solid black;"><span style="color: black;">' + stackable  +' </span></td></tr>';
                    }
                    containers = containers + '</table>';                
                    me.editorcp='<p style:"padding: 0 50px;">' + basis + tipoO + vgm + custom + insurance + maneuvers + comodity+foodgrade+npuertoreceipt+npuertoloading+npuertodischarge+npuertodelivery+freedaysorigin+freedaysdest+remarks+inland+direccionreceipcompleta+direcciondeliverypcompleta+containers+'</p>';
                    me.cpasunto = 'Solicitud de Cotización '+ me.edittarifa.ncotizacion;
                    me.ListarFile(me.edittarifa.idscotizacion);
                }
            }).catch(function(error){
                console.log(error);
            });   
        },
        EnviraMail(){
            let loader = Vue.$loading.show({color: '#189bec',loader: 'spinner'});
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;
            axios.post('api/Scotizaciones/EnviarMail',{
              asunto:model.cpasunto,
              idusuario:this.$store.state.usuario.idusuario,
              idcustumer:model.edittarifa.idcustumer,
              ncotizacion:model.ncotizacion,
              contenido:model.editorcp,
              contactoscc:model.contactoscc,
              inland:model.ncotizacion,
              namefiles:model.containerFile,
            },configuracion).then(function(response){
                  loader.hide()
                  model.snackbar = true 
                  model.mensaje = 'Correo enviado correctamente'
                  model.dialog2 = false
            }).catch(function(error){
                loader.hide()                                                
                console.log(error); 
                model.snackbar = true
                model.text = error
            });
        },
        cargarInformacion(item){
            this.editedIndex = this.tarifasListar.indexOf(item)               
            this.edittarifa = Object.assign({}, item) 
            console.log(this.edittarifa) 
            var i;
            for (i = 0;  i< this.edittarifa.length; i ++) {
             console.log(this.editedIndex[i].basis);
            }
             this.dialog3 = true;
        },
        agregarTarifa(item){  
            console.log('item')
            console.log(item)
            console.log(this.$store.state.usuario.rol)
            this.editedIndextarif = -1;
            this.tarifas  = [];
            this.chargeaditional = [];
            this.viewtarifaprincipal = false;
            this.viewpickup = false;
            this.viewdelivery = false;
            this.adicionalespricing = false;
            this.adicionalesagentes = false;
            this.edittarifa = Object.assign({}, item)
            this.freedaysorigin = item.freedaysorigin;
            this.freedaysdest = item.freedaysdest;
            if(this.edittarifa.basis == 'FCL' || this.edittarifa.basis == 'FTL' ){
                this.cargarContainer(this.edittarifa.idscotizacion);
            }else{
                this.listarpackage(this.edittarifa.idscotizacion);
            }
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion = {headers:header};
            me.tarifasprincipales = [];
            axios.get('api/ListaTarifasPricings/ListarTarifas/' + me.edittarifa.idscotizacion + '/' +  this.$store.state.usuario.rol,configuracion).then(function(response){                
                me.listart=response.data;
                console.log('me.listart')
                console.log(me.listart)
                me.listart.map(function(x){
                    if(me.rolejecutivo != 'Operaciones'){
                        if(x.tarifaprincipal == true){
                            me.viewtarifaprincipal = true;
                            me.tarifasprincipales.push({
                                delivery:x.delivery,
                                descripcion:x.descripcion,
                                idlistatarifa:x.idlistatarifa,
                                idscotizacion:x.idscotizacion,
                                pickup:x.pickup,
                                pricing:x.pricing,
                                tarifaadicional:x.tarifaadicional,
                                tarifaprincipal:x.tarifaprincipal,
                                activo:true,
                            });
                        }
                        if(x.pickup == true){
                            me.viewpickup = true;
                            me.tarifasprincipales.push({
                                delivery:x.delivery,
                                descripcion:x.descripcion,
                                idlistatarifa:x.idlistatarifa,
                                idscotizacion:x.idscotizacion,
                                pickup:x.pickup,
                                pricing:x.pricing,
                                tarifaadicional:x.tarifaadicional,
                                tarifaprincipal:x.tarifaprincipal,
                                activo:true,
                            });
                        }
                        if(x.delivery == true){
                            me.viewdelivery = true;
                            me.tarifasprincipales.push({
                                delivery:x.delivery,
                                descripcion:x.descripcion,
                                idlistatarifa:x.idlistatarifa,
                                idscotizacion:x.idscotizacion,
                                pickup:x.pickup,
                                pricing:x.pricing,
                                tarifaadicional:x.tarifaadicional,
                                tarifaprincipal:x.tarifaprincipal,
                                activo:true,
                            });
                        }
                    }
                    if(x.tarifaadicional == 'insurance' || x.tarifaadicional == 'custody' || x.tarifaadicional == 'custom' || x.tarifaadicional == 'maneuvers' || x.tarifaadicional == 'vgm'){
                        if(x.pricing  == 'Pricing'){
                            me.adicionalespricing = true;
                        }
                        if(x.pricing  == 'PricingAgente'){
                            me.adicionalesagentes = true;
                        }
                        me.agregartarifalist();
                    }
                });
                me.adModal4=true;
            }).catch(function(error){
                console.log(error);
            });
        },
        cargarContainer(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.containers = [];
            axios.get('api/DatosContainerUnits/ListarContainers/'+ id,configuracion).then(function(response){                
                me.containers = response.data;
            }).catch(function(error){
                console.log(error);
            });
            this.idscotizacion = id;
            this.listartarifag(this.idscotizacion)
        },
        listartarifag(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.tarifas = [];
            var arrayt = [];
            var consulta = '';
            if(this.edittarifa.basis == 'FCL' || this.edittarifa.basis == 'FTL'){
                consulta = 'ListarContainers';
            }else{
                consulta = 'ListarContainersUsersLCL';
            }
            axios.get('api/tarifaContainers/' + consulta + '/'+ id +'/'+ this.$store.state.usuario.rol ,configuracion).then(function(response){
                me.tarifas = response.data;
            }).catch(function(error){
                console.log(error);
            });
        },
        listarpackage(id){
            console.log('i -- d')
            console.log(id)
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            console.log('me.idscotizacion')
            console.log(id)
            axios.get('api/Packages/ListarPackage/'+ id,configuracion).then(function(response){                
                me.addpackages=response.data;
                me.listartarifag(id)
            }).catch(function(error){
                console.log(error);
            });
        },
        agregartarifas(){
            this.ejecutando = false;
            var exclusivo = 0;
            var general = 0;
            var ex;

            if(this.radios == 1){
                exclusivo = 1;
                ex = "Exclusive Rate";
            }else{
                general = 1;
                ex = "General Rate";
            }
            
            var moneda = "";
            console.log('this.idmoneda')
            console.log(this.idmoneda)
            if(this.idmoneda == ""){

            }
                if (this.editedIndextarif > -1) {
                    if(this.edittarifa.basis =='LTL' || this.edittarifa.basis =='LCL' || this.edittarifa.basis =='AEREO'){
                        var origen = 0;
                        var destino = 0;
                        for (var j = 0; j < this.tarifasprincipales.length; j++) {
                            var provider;
                            var idprovider;
                            var idmoneda = 0;
                            var moneda = '';
                            if(this.chekfreedaysorigin != 'infoorigin' || this.chekfreedaysorigin == null || this.chekfreedaysorigin == false){
                                origen = this.tarifasprincipales[j].freedaysorigin;
                                if(this.tarifasprincipales[j].freedaysorigin == undefined || this.tarifasprincipales[j].freedaysorigin == ''){
                                    origen = 0;
                                }
                            }else{
                                origen = this.freedaysorigin;
                            }
                            if(this.checkfreedaysdest != 'infodest' || this.checkfreedaysdest == null || this.checkfreedaysdest == false){
                                destino = this.tarifasprincipales[j].freedaysdest;
                                if(this.tarifasprincipales[j].freedaysdest == undefined || this.tarifasprincipales[j].freedaysdest == ''){
                                    destino = 0;
                                }
                            }else{
                                destino = this.freedaysdest;
                            }
                            if(this.edittarifa.basis =='FTL'){
                                origen = 0;
                                destino = 0;
                            }
                            if(this.tarifasprincipales[j].idprovider.text == undefined){
                                idprovider = this.tarifasprincipales[j].idprovider;
                                provider = this.tarifasprincipales[j].nidprovider;
                            }else{
                                idprovider = this.tarifasprincipales[j].idprovider.value;
                                provider = this.tarifasprincipales[j].idprovider.text;
                            }
                            if(this.tarifasprincipales[j].idmoneda.text == undefined){
                                idmoneda = this.tarifasprincipales[j].idmoneda;
                                moneda = this.tarifasprincipales[j].moneda;
                            }else{
                                idmoneda = this.tarifasprincipales[j].idmoneda.value;
                                moneda = this.tarifasprincipales[j].idmoneda.text;
                            }
                            Object.assign(this.tarifas[this.editedIndextarif], {
                                idlistarifarate:this.tarifasprincipales[j].idlistarifarate,
                                quantity:1,
                                size:'',
                                type:'',   
                                idsize:10,
                                idtype:15,
                                nweight:'',
                                weight:0,
                                rate:this.tarifasprincipales[j].rate,
                                nrate:this.tarifasprincipales[j].rate + ' ' + moneda,
                                moneda:moneda,
                                idmoneda:idmoneda,
                                idprovider:idprovider,
                                idagent:1,//this.containers[i].idagent.value,
                                nidprovider:provider,
                                nidagent:'agente',//this.containers[i].idagent.text,
                                observaciones:this.tarifasprincipales[0].observaciones,
                                tarifaAd:this.tarifasprincipales[0].tarifaAd,
                                idcontainer:0,
                                freedaysorigin:origen,
                                freedasydestination:destino,
                                ex:ex,
                                exclusivo:exclusivo,
                                general:general,
                                vigencia:this.tarifasprincipales[j].date,
                                fechavigencia:this.tarifasprincipales[j].date,
                                descripcion:this.tarifasprincipales[j].descripcion,
                                rol:this.$store.state.usuario.rol,
                                activo:true,
                            });
                            this.tarifasprincipales[j].date = '';
                            this.tarifasprincipales[j].tarifaAd = '';
                            this.tarifasprincipales[j].observaciones = '';
                            this.tarifasprincipales[j].idprovider = '';
                            this.tarifasprincipales[j].idmoneda = 0;
                            this.tarifasprincipales[j].rate = '';
                            this.tarifasprincipales[j].freedaysorigin = '';
                            this.tarifasprincipales[j].freedaysdest = '';
                            this.chekfreedaysorigin = false;
                            this.checkfreedaysdest  = false;
                            this.tarifasprincipales.push();
                        }
                    }else{
                        var origen = 0;
                        var destino = 0;
                        var j;
                        var i;
                        for (i = 0; i < this.containers.length; i++) {
                            for (j = 0; j < this.tarifasprincipales.length; j++) {
                                if(this.chekfreedaysorigin != 'infoorigin' || this.chekfreedaysorigin == null || this.chekfreedaysorigin == false){
                                    origen = this.tarifasprincipales[j].freedaysorigin;
                                    if(this.tarifasprincipales[j].freedaysorigin == undefined || this.tarifasprincipales[j].freedaysorigin == ''){
                                        origen = 0;
                                    }
                                }else{
                                    origen = this.freedaysorigin;
                                }
                                if(this.checkfreedaysdest != 'infodest' || this.checkfreedaysdest == null || this.checkfreedaysdest == false){
                                    destino = this.tarifasprincipales[j].freedaysdest;
                                    if(this.tarifasprincipales[j].freedaysdest == undefined || this.tarifasprincipales[j].freedaysdest == ''){
                                        destino = 0;
                                    }
                                }else{
                                    destino = this.freedaysdest;
                                }
                                if(this.edittarifa.basis =='FTL'){
                                    origen = 0;
                                    destino = 0;
                                }
                                var provider;
                                var idprovider;
                                var idmoneda = 0;
                                var moneda = '';
                                if(this.tarifasprincipales[j].idprovider.text == undefined){
                                    idprovider = this.tarifasprincipales[j].idprovider;
                                    provider = this.tarifasprincipales[j].nidprovider;
                                }else{
                                    idprovider = this.tarifasprincipales[j].idprovider.value;
                                    provider = this.tarifasprincipales[j].idprovider.text;
                                }
                                if(this.tarifasprincipales[j].idmoneda.text == undefined){
                                    idmoneda = this.tarifasprincipales[j].idmoneda;
                                    moneda = this.tarifasprincipales[j].moneda;
                                }else{
                                    idmoneda = this.tarifasprincipales[j].idmoneda.value;
                                    moneda = this.tarifasprincipales[j].idmoneda.text;
                                }
                                if(this.containers[i].containerseleccionado == true){
                                    Object.assign(this.tarifas[this.editedIndextarif], {
                                        idlistarifarate:this.tarifasprincipales[j].idlistarifarate,
                                        quantity:this.containers[i].quantity,
                                        size:this.containers[i].size,
                                        type:this.containers[i].type,   
                                        idsize:this.containers[i].idsize,
                                        idtype:this.containers[i].idtype,
                                        ntype:this.containers[i].size + " "+ this.containers[i].type,
                                        nweight:this.containers[i].nweight,
                                        weight:this.containers[i].weight,
                                        rate:this.tarifasprincipales[j].rate,
                                        nrate:this.tarifasprincipales[j].rate + ' ' + moneda,
                                        moneda:moneda,
                                        idmoneda:idmoneda,
                                        idprovider:idprovider,
                                        idagent:1,//this.containers[i].idagent.value,
                                        nidprovider:provider,
                                        nidagent:'agente',//this.containers[i].idagent.text,
                                        observaciones:this.tarifasprincipales[j].observaciones,
                                        tarifaAd:this.tarifasprincipales[j].tarifaAd,
                                        idcontainer:this.containers[i].idcontainer,
                                        freedaysorigin:origen,
                                        freedasydestination:destino,
                                        ex:ex,
                                        exclusivo:exclusivo,
                                        general:general,
                                        vigencia:this.tarifasprincipales[j].date,
                                        fechavigencia:this.tarifasprincipales[j].date,
                                        descripcion:this.tarifasprincipales[j].descripcion,
                                        rol:this.$store.state.usuario.rol,
                                        activo:true,
                                    });
                                    this.tarifasprincipales[j].date = '';
                                    this.tarifasprincipales[j].tarifaAd = '';
                                    this.tarifasprincipales[j].observaciones = '';
                                    this.tarifasprincipales[j].idprovider = '';
                                    this.tarifasprincipales[j].idmoneda = 0;
                                    this.tarifasprincipales[j].rate = '';
                                    this.tarifasprincipales[j].freedaysorigin = '';
                                    this.tarifasprincipales[j].freedaysdest = '';
                                    this.tarifasprincipales.push();
                                    this.containers[i].containerseleccionado = false;
                                    this.chekfreedaysorigin = false;
                                    this.checkfreedaysdest  = false;
                                }
                            }
                        }
                    }
                    this.editedIndextarif = -1;
                } else {
                    var origen = 0;
                    var destino = 0;
                    if(this.edittarifa.basis =='LTL' || this.edittarifa.basis =='LCL' || this.edittarifa.basis =='AEREO'){
                            for (var j = 0; j <= this.tarifasprincipales.length; j++) {
                                if(this.chekfreedaysorigin != 'infoorigin' || this.chekfreedaysorigin == null || this.chekfreedaysorigin == false){
                                    origen = this.tarifasprincipales[j].freedaysorigin;
                                }else{
                                    origen = this.freedaysorigin;
                                }
                                if(this.checkfreedaysdest != 'infodest' || this.checkfreedaysdest == null || this.checkfreedaysdest == false){
                                    destino = this.tarifasprincipales[j].freedaysdest;
                                }else{
                                    destino = this.freedaysdest;
                                }
                                if(destino == undefined || destino == ''){
                                    destino = 0;
                                }
                                if(origen == undefined || origen == ''){
                                    origen = 0;
                                }
                                if(this.tarifasprincipales[j].idmoneda != undefined && this.tarifasprincipales[j].idprovider != undefined){
                                    this.tarifas.push({
                                        idlistarifarate:0,
                                        quantity:1,
                                        size:'',
                                        type:'',   
                                        idsize:10,
                                        idtype:15,
                                        nweight:'',
                                        weight:0,
                                        rate:this.tarifasprincipales[j].rate,
                                        nrate:this.tarifasprincipales[j].rate + ' ' + this.tarifasprincipales[j].idmoneda.text,
                                        moneda:this.tarifasprincipales[j].idmoneda.text,
                                        idmoneda:this.tarifasprincipales[j].idmoneda.value,
                                        idprovider:this.tarifasprincipales[j].idprovider.value,
                                        idagent:1,//this.containers[i].idagent.value,
                                        nidprovider:this.tarifasprincipales[j].idprovider.text,
                                        nidagent:'agente',//this.containers[i].idagent.text,
                                        observaciones:this.tarifasprincipales[j].observaciones,
                                        tarifaAd:this.tarifasprincipales[j].tarifaAd,
                                        idcontainer:0,
                                        freedaysorigin:origen,
                                        freedasydestination:destino,
                                        ex:ex,
                                        exclusivo:exclusivo,
                                        general:general,
                                        vigencia:this.tarifasprincipales[j].date,
                                        fechavigencia:this.tarifasprincipales[j].date,
                                        descripcion:this.tarifasprincipales[j].descripcion,
                                        rol:this.$store.state.usuario.rol,
                                        activo:true,
                                    });
                                    this.tarifasprincipales[j].date = '';
                                    this.tarifasprincipales[j].tarifaAd = '';
                                    this.tarifasprincipales[j].observaciones = '';
                                    this.tarifasprincipales[j].idprovider = undefined;
                                    this.tarifasprincipales[j].idmoneda = undefined;
                                    this.tarifasprincipales[j].rate = '';
                                    this.tarifasprincipales[j].freedaysorigin = '';
                                    this.tarifasprincipales[j].freedaysdest = '';
                                }
                            }
                    }else{
                        var origen = 0;
                        var destino = 0;
                        var j;
                        var i;
                        for (i = 0; i < this.containers.length; i++) {
                            for (j = 0; j < this.tarifasprincipales.length; j++) {
                                if(this.chekfreedaysorigin != 'infoorigin' || this.chekfreedaysorigin == null || this.chekfreedaysorigin == false){
                                    console.log(this.tarifasprincipales[j].freedaysorigin)
                                    origen = this.tarifasprincipales[j].freedaysorigin;
                                    if(this.tarifasprincipales[j].freedaysorigin == undefined){
                                        origen = 0;
                                    }
                                }else{
                                    origen = this.freedaysorigin;
                                }
                                if(this.checkfreedaysdest != 'infodest' || this.checkfreedaysdest == null || this.checkfreedaysdest == false){
                                    destino = this.tarifasprincipales[j].freedaysdest;
                                    if(this.tarifasprincipales[j].freedaysdest == undefined){
                                        destino = 0;
                                    }
                                }else{
                                    destino = this.freedaysdest;
                                }
                                if(this.edittarifa.basis =='FTL'){
                                    origen = 0;
                                    destino = 0;
                                }
                                if(this.tarifasprincipales[j].idmoneda != undefined && this.tarifasprincipales[j].idprovider != undefined ){
                                    if(this.containers[i].containerseleccionado == true){
                                        this.tarifas.push({
                                            idlistarifarate:0,
                                            quantity:this.containers[i].quantity,
                                            size:this.containers[i].size,
                                            type:this.containers[i].type,   
                                            idsize:this.containers[i].idsize,
                                            idtype:this.containers[i].idtype,
                                            ntype:this.containers[i].size + " "+ this.containers[i].type,
                                            nweight:this.containers[i].nweight,
                                            weight:this.containers[i].weight,
                                            rate:this.tarifasprincipales[j].rate,
                                            nrate:this.tarifasprincipales[j].rate + ' ' + this.tarifasprincipales[j].idmoneda.text,
                                            moneda:this.tarifasprincipales[j].idmoneda.text,
                                            idmoneda:this.tarifasprincipales[j].idmoneda.value,
                                            idprovider:this.tarifasprincipales[j].idprovider.value,
                                            idagent:1,//this.containers[i].idagent.value,
                                            nidprovider:this.tarifasprincipales[j].idprovider.text,
                                            nidagent:'agente',//this.containers[i].idagent.text,
                                            observaciones:this.tarifasprincipales[j].observaciones,
                                            tarifaAd:this.tarifasprincipales[j].tarifaAd,
                                            idcontainer:this.containers[i].idcontainer,
                                            freedaysorigin:origen,
                                            freedasydestination:destino,
                                            ex:ex,
                                            exclusivo:exclusivo,
                                            general:general,
                                            vigencia:this.tarifasprincipales[j].date,
                                            fechavigencia:this.tarifasprincipales[j].date,
                                            descripcion:this.tarifasprincipales[j].descripcion,
                                            rol:this.$store.state.usuario.rol,
                                            activo:true,
                                        });
                                        this.tarifasprincipales[j].date = '';
                                        this.tarifasprincipales[j].tarifaAd = '';
                                        this.tarifasprincipales[j].observaciones = '';
                                        this.tarifasprincipales[j].idprovider = undefined;
                                        this.tarifasprincipales[j].idmoneda = undefined;
                                        this.tarifasprincipales[j].rate = '';
                                        this.tarifasprincipales[j].freedaysorigin = '';
                                        this.tarifasprincipales[j].freedaysdest = '';

                                    }
                                }
                            }
                        }
                    }      
            }
        },
        agregartarifalist(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion = {headers:header};
            axios.get('api/Listarifarates/ListarTarifaEx/' + me.edittarifa.idscotizacion + '/'+ me.$store.state.usuario.rol ,configuracion).then(function(response){                
                me.chargeaditional=response.data;
            }).catch(function(error){
                console.log(error);
            });
        },
        limpiar(){
            for (var i = 0; i <= this.containers.length; i++) {
                this.containers[i].rate = '';
                this.containers[i].idprovider = '';
                this.containers[i].idagent = '';
                this.containers[i].idprovider = '';
                this.containers[i].idagent = '';
                this.containers[i].date = '';
            }
            this.idmoneda = '';
            this.editedIndextarif = -1;
        },
        actualizarTarifa(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion
            me.loadingsave = true;
            me.ejecutando = true;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header}
            axios.put('api/Scotizaciones/Actualizar',{
                'idscotizacion':me.edittarifa.idscotizacion,
                'tarifasContenedorViewModels':me.tarifas,
                'ListatarifaContenedorViewModels':me.chargeaditional,
                'rol':this.$store.state.usuario.rol
            },configuracion).then(function(response){
                me.adModal4 = false
                me.snackbar = true
                me.mensaje = 'Tarifa Guardada correctamente'
                me.listar();
                me.loadingsave = false;
               // me.ejecutando = false;
            }).catch(function(error){
                console.log(error);
                me.loadingsave = false;
            });
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        deleteItemc(item) {
            
           const index = this.tarifas.indexOf(item);
           var resp = confirm('Are you sure you want to delete this tarif?');
           if(resp == true){
                this.tarifas[index].activo = false;
                this.ejecutando = false;
           }
        },
        editItemc(item){
            this.editedIndextarif = this.tarifas.indexOf(item)
            var i;
            for(i = 0; i < this.tarifasprincipales.length; i++){
                if(this.tarifasprincipales[i].descripcion == item.descripcion){
                    this.tarifasprincipales[i].rate = item.rate
                    this.tarifasprincipales[i].idprovider =  item.idprovider;
                    this.tarifasprincipales[i].idmoneda = item.idmoneda;
                    this.tarifasprincipales[i].freedaysorigin = item.freedaysorigin;
                    this.tarifasprincipales[i].freedaysdest = item.freedasydestination;
                    this.tarifasprincipales[i].observaciones = item.observaciones;
                    this.tarifasprincipales[i].tarifaAd = item.tarifaAd;
                    this.tarifasprincipales[i].date = item.fechavigenciaedit;
                    this.tarifasprincipales[i].idlistarifarate = item.idlistarifarate;
                    this.tarifasprincipales[i].general = item.general;
                    this.tarifasprincipales[i].exclusivo = item.exclusivo;
                    this.tarifasprincipales[i].idscotizacion = item.idscotizacion;
                    this.tarifasprincipales[i].idsize = item.idsize;
                    this.tarifasprincipales[i].idtype = item.idtype;
                    this.tarifasprincipales[i].quantity = item.quantity;
                    this.tarifasprincipales[i].activo = item.activo;
                    this.tarifasprincipales[i].moneda = item.moneda;
                    this.tarifasprincipales[i].nidprovider = item.nidprovider;
                }
                for(var j=0; j < this.containers.length; j++){
                    if(this.containers[j].idsize == this.tarifasprincipales[i].idsize){
                        this.containers[j].containerseleccionado = true;
                    }
                }
            }
            if(this.edittarifa.freedaysorigin == item.freedaysorigin){
                this.chekfreedaysorigin = 'infoorigin';
            }else{
                this.freedaysorigin = item.freedaysorigin;
            }
            if(this.edittarifa.freedasydestination == item.freedasydestination){
                this.checkfreedaysdest = 'infodest';
            }else{
                this.freedasydestination = item.freedasydestination;
            }
            this.tarifasprincipales.push();
        },
        /*----------------Colors---------------*/
        getColor (status) {
            if (status == false) return 'rgb(218,20,6)'
            //else if (status == 'Negociación') return 'rgb(239,144,5)'
            else if(status == true) return '#4caf50'
        },
    },
    
}
</script>
